import {
  __export
} from "./chunk-5VRACIDE.mjs";

// packages/apps/patterns/react-ui/src/components/Clipboard/CopyButton.tsx
import { Check, Copy } from "@phosphor-icons/react";
import React2 from "react";
import { Button, getSize, mx, useTranslation } from "@dxos/react-components";

// packages/apps/patterns/react-ui/src/components/Clipboard/ClipboardProvider.tsx
import React, { createContext, useCallback, useContext, useState } from "react";
var ClipboardContext = /* @__PURE__ */ createContext({
  textValue: "",
  setTextValue: async (_) => {
  }
});
var useClipboardContext = () => useContext(ClipboardContext);
var ClipboardProvider = ({ children }) => {
  const [textValue, setInternalTextValue] = useState("");
  const setTextValue = useCallback(async (nextValue) => {
    await navigator.clipboard.writeText(nextValue);
    return setInternalTextValue(nextValue);
  }, []);
  return /* @__PURE__ */ React.createElement(ClipboardContext.Provider, {
    value: {
      textValue,
      setTextValue
    }
  }, children);
};

// packages/apps/patterns/react-ui/src/components/Clipboard/CopyButton.tsx
var inactiveLabelStyles = "invisible bs-px -mbe-px";
var CopyButton = ({ value }) => {
  const { t } = useTranslation("os");
  const { textValue, setTextValue } = useClipboardContext();
  const isCopied = textValue === value;
  return /* @__PURE__ */ React2.createElement(Button, {
    className: "inline-flex flex-col justify-center",
    onClick: () => setTextValue(value),
    "data-testid": "copy-invitation"
  }, /* @__PURE__ */ React2.createElement("div", {
    role: "none",
    className: mx("flex gap-1", isCopied && inactiveLabelStyles)
  }, /* @__PURE__ */ React2.createElement("span", {
    className: "pli-1"
  }, t("copy invitation code label")), /* @__PURE__ */ React2.createElement(Copy, {
    className: getSize(4),
    weight: "bold"
  })), /* @__PURE__ */ React2.createElement("div", {
    role: "none",
    className: mx("flex gap-1", !isCopied && inactiveLabelStyles)
  }, /* @__PURE__ */ React2.createElement("span", {
    className: "pli-1"
  }, t("copy invitation code success label")), /* @__PURE__ */ React2.createElement(Check, {
    className: getSize(4),
    weight: "bold"
  })));
};

// packages/apps/patterns/react-ui/src/components/IdentityList/DeviceList.tsx
import React4 from "react";

// packages/apps/patterns/react-ui/src/components/IdentityList/IdentityListItem.tsx
import React3 from "react";
import { SpaceMember } from "@dxos/client";
import { Avatar, mx as mx2, useTranslation as useTranslation2 } from "@dxos/react-components";
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var IdentityListItem = ({ identity, presence, onClick }) => {
  var _a, _b;
  const { t } = useTranslation2("os");
  return /* @__PURE__ */ React3.createElement("li", {
    className: mx2("flex gap-2 items-center", onClick && "cursor-pointer"),
    onClick: () => onClick == null ? void 0 : onClick(),
    "data-testid": "identity-list-item"
  }, /* @__PURE__ */ React3.createElement(Avatar, _extends({}, {
    variant: "circle",
    size: 9,
    fallbackValue: identity.identityKey.toHex(),
    label: /* @__PURE__ */ React3.createElement("p", {
      className: "text-sm truncate"
    }, (_b = (_a = identity.profile) == null ? void 0 : _a.displayName) != null ? _b : identity.identityKey.truncate()),
    ...presence === SpaceMember.PresenceState.OFFLINE && {
      status: "inactive",
      description: /* @__PURE__ */ React3.createElement("p", {
        className: "font-system-normal text-xs text-neutral-700 dark:text-neutral-300"
      }, t("identity offline description"))
    },
    ...presence === SpaceMember.PresenceState.ONLINE && {
      status: "active"
    },
    slots: {
      labels: {
        className: "block shrink overflow-hidden"
      },
      root: {
        className: "shrink-0"
      }
    }
  })));
};

// packages/apps/patterns/react-ui/src/components/IdentityList/DeviceList.tsx
var DeviceList = ({ devices, onSelect }) => {
  return /* @__PURE__ */ React4.createElement("ul", {
    className: "flex flex-col gap-2"
  }, devices.map((device) => {
    var _a;
    const identity = {
      identityKey: device.deviceKey,
      profile: {
        displayName: (_a = device.profile) == null ? void 0 : _a.displayName
      }
    };
    return /* @__PURE__ */ React4.createElement(IdentityListItem, {
      key: device.deviceKey.toHex(),
      identity,
      onClick: onSelect && (() => onSelect(device))
    });
  }));
};

// packages/apps/patterns/react-ui/src/components/IdentityList/SpaceMemberList.tsx
import React5 from "react";
var SpaceMemberList = ({ members, onSelect }) => {
  return /* @__PURE__ */ React5.createElement("ul", {
    className: "flex flex-col gap-2"
  }, members.filter((member) => member.identity).map((member) => {
    return /* @__PURE__ */ React5.createElement(IdentityListItem, {
      key: member.identity.identityKey.toHex(),
      identity: member.identity,
      presence: member.presence,
      onClick: onSelect && (() => onSelect(member))
    });
  }));
};

// packages/apps/patterns/react-ui/src/components/IdentityList/SpaceMemberListContainer.tsx
import React6, { useMemo } from "react";
import { useClient, useMembers } from "@dxos/react-client";
var SpaceMemberListContainer = ({ spaceKey, includeSelf, onSelect }) => {
  const client = useClient();
  const allUnsortedMembers = useMembers(spaceKey);
  const members = useMemo(() => includeSelf ? allUnsortedMembers.sort((a) => a.identity.identityKey.equals(client.halo.identity.get().identityKey) ? -1 : 1) : allUnsortedMembers.filter((member) => !member.identity.identityKey.equals(client.halo.identity.get().identityKey)), [
    allUnsortedMembers
  ]);
  return /* @__PURE__ */ React6.createElement(SpaceMemberList, {
    members,
    onSelect
  });
};

// packages/apps/patterns/react-ui/src/components/InvitationEmoji/InvitationEmoji.tsx
import React7 from "react";
import { getSize as getSize2, mx as mx3 } from "@dxos/react-components";

// packages/apps/patterns/react-ui/src/util/invitationStatusValue.ts
import { Invitation } from "@dxos/client";
var invitationStatusValue = /* @__PURE__ */ new Map([
  [
    Invitation.State.ERROR,
    -3
  ],
  [
    Invitation.State.TIMEOUT,
    -2
  ],
  [
    Invitation.State.CANCELLED,
    -1
  ],
  [
    Invitation.State.INIT,
    0
  ],
  [
    Invitation.State.CONNECTING,
    1
  ],
  [
    Invitation.State.CONNECTED,
    2
  ],
  [
    Invitation.State.READY_FOR_AUTHENTICATION,
    3
  ],
  [
    Invitation.State.AUTHENTICATING,
    4
  ],
  [
    Invitation.State.SUCCESS,
    5
  ]
]);

// packages/apps/patterns/react-ui/src/util/toEmoji.ts
import toArray from "lodash.toarray";
var emoji = toArray(
  // When changing this set, please check the result in a console or e.g. RunKit (https://runkit.com/thure/642214441dd6ae000855a8de)
  // Emoji sometimes use a combination of code points, and some code points aren't visible on their own, so by adding or deleting you may unintentionally create non-visible items.
  // This set was chosen from the characters in Unicode Emoji v15.0 based on the following criteria:
  // – not people or isolated anthropomorphic faces
  // – not flags
  // – more concrete than abstract
  // – less culturally specific
  // – less easily confused with another emoji in the set
  // – requires less special knowledge to identify
  // – less likely to evoke negative feelings (no meat, no drugs, no weapons, etc)
  // – less common as a signifier in UX
  "\u{1F479}\u{1F47B}\u{1F47D}\u{1F916}\u{1F383}\u{1F9BE}\u{1F9BF}\u{1F9B7}\u{1F463}\u{1F441}\uFE0F\u{1F9F6}\u{1F451}\u{1F412}\u{1F986}\u{1F989}\u{1F434}\u{1F984}\u{1F41D}\u{1F98B}\u{1F41E}\u{1FAB2}\u{1F422}\u{1F98E}\u{1F995}\u{1F991}\u{1F980}\u{1F420}\u{1F42C}\u{1F40B}\u{1F9AD}\u{1F405}\u{1F406}\u{1F993}\u{1F98D}\u{1F9A7}\u{1F418}\u{1F42B}\u{1F992}\u{1F998}\u{1F9AC}\u{1F416}\u{1F40F}\u{1F98C}\u{1F415}\u{1F408}\u{1F413}\u{1F99A}\u{1F99C}\u{1F9A2}\u{1F9A9}\u{1F9A6}\u{1F401}\u{1F43F}\uFE0F\u{1F335}\u{1F332}\u{1F333}\u{1FAB5}\u{1F331}\u{1F341}\u{1FABA}\u{1F344}\u{1F41A}\u{1FAB8}\u{1FAA8}\u{1F33E}\u{1F337}\u{1F33B}\u2600\uFE0F\u{1F319}\u{1FA90}\u2B50\uFE0F\u26A1\uFE0F\u2604\uFE0F\u{1F525}\u{1F308}\u2601\uFE0F\u{1F4A7}\u26F1\uFE0F\u{1F30A}\u{1F34E}\u{1F34B}\u{1F349}\u{1F347}\u{1FAD0}\u{1F348}\u{1F352}\u{1F351}\u{1F96D}\u{1F34D}\u{1F965}\u{1F95D}\u{1F951}\u{1F336}\uFE0F\u{1F33D}\u{1F955}\u{1F36C}\u{1F95C}\u{1FAD6}\u2615\uFE0F\u{1F375}\u{1F9CA}\u{1F9C2}\u{1F3D4}\uFE0F\u2693\uFE0F\u{1F6DF}\u{1F3DD}\uFE0F\u{1F6F6}\u{1F680}\u{1F6F0}\uFE0F\u26F2\uFE0F\u{1F3F0}\u{1F6B2}\u26FA\uFE0F\u{1F399}\uFE0F\u{1F9F2}\u2699\uFE0F\u{1F529}\u{1F52E}\u{1F52D}\u{1F52C}\u{1F9EC}\u{1F321}\uFE0F\u{1F9FA}\u{1F6CE}\uFE0F\u{1F511}\u{1FA91}\u{1F9F8}\u{1F388}\u{1F380}\u{1F38A}\u267B\uFE0F\u{1F3B5}"
);
var toEmoji = (keyAsHex) => emoji[parseInt(keyAsHex, 16) % emoji.length];

// packages/apps/patterns/react-ui/src/components/InvitationEmoji/InvitationEmoji.tsx
function _extends2() {
  _extends2 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends2.apply(this, arguments);
}
var InvitationEmoji = ({ invitationId, size = "lg", ...rootProps }) => {
  const invitationEmoji = invitationId && toEmoji(invitationId);
  return /* @__PURE__ */ React7.createElement("div", _extends2({
    role: "none"
  }, rootProps, {
    className: mx3(getSize2(size === "sm" ? 8 : 12), "inline-flex items-center justify-center leading-none", size === "sm" ? "text-2xl" : "text-5xl bg-neutral-300 dark:bg-neutral-700 rounded-full", rootProps.className)
  }), /* @__PURE__ */ React7.createElement("span", {
    role: "none"
  }, invitationEmoji));
};

// packages/apps/patterns/react-ui/src/components/InvitationList/InvitationStatusAvatar.tsx
import React8 from "react";
import { Invitation as Invitation3 } from "@dxos/client";
import { getSize as getSize3, mx as mx4 } from "@dxos/react-components";

// packages/apps/patterns/react-ui/src/styles/dialogStyles.ts
var defaultOverlay = "fixed inset-0 backdrop-blur z-50 overflow-auto grid place-items-center p-2 md:p-4 lg:p-8";
var defaultDialogContent = "is-full min-is-[260px] max-is-[320px] rounded-md shadow-md backdrop-blur-md";

// packages/apps/patterns/react-ui/src/styles/panelStyles.ts
var defaultSurface = "bg-neutral-50/[.72] dark:bg-neutral-950/[.72]";
var subduedSurface = "bg-neutral-100/[.66] dark:bg-neutral-900/[.66]";
var defaultArrow = "text-neutral-50/[.66] dark:text-neutral-950/[.66]";

// packages/apps/patterns/react-ui/src/styles/invitationStatusStyles.ts
import { Invitation as Invitation2 } from "@dxos/client";
var inactiveBgColor = "bg-neutral-100 dark:bg-neutral-600";
var activeBgColor = "bg-primary-500 dark:bg-primary-400";
var successBgColor = "bg-success-500 dark:bg-success-400";
var errorBgColor = "bg-error-500 dark:bg-error-400";
var cancelledBgColor = "bg-warning-500 dark:bg-warning-400";
var inactiveTextColor = "text-neutral-100 dark:text-neutral-600";
var activeTextColor = "text-primary-400 dark:text-primary-500";
var successTextColor = "text-success-400 dark:text-success-500";
var errorTextColor = "text-error-400 dark:text-error-500";
var cancelledTextColor = "text-warning-400 dark:text-warning-500";
var inactiveStrokeColor = "stroke-neutral-100 dark:stroke-neutral-700";
var activeStrokeColor = "stroke-primary-500 dark:stroke-primary-150";
var successStrokeColor = "stroke-success-400 dark:stroke-primary-400";
var errorStrokeColor = "stroke-error-400 dark:stroke-error-500";
var cancelledStrokeColor = "stroke-warning-400 dark:stroke-warning-500";
var resolvedStrokeColor = (status) => status === Invitation2.State.ERROR ? errorStrokeColor : status === Invitation2.State.CANCELLED || status === Invitation2.State.TIMEOUT ? cancelledStrokeColor : successStrokeColor;
var resolvedBgColor = (status) => status === Invitation2.State.ERROR ? errorBgColor : status === Invitation2.State.CANCELLED || status === Invitation2.State.TIMEOUT ? cancelledBgColor : successBgColor;
var resolvedTextColor = (status) => status === Invitation2.State.ERROR ? errorTextColor : status === Invitation2.State.CANCELLED || status === Invitation2.State.TIMEOUT ? cancelledTextColor : successTextColor;

// packages/apps/patterns/react-ui/src/components/InvitationList/InvitationStatusAvatar.tsx
function _extends3() {
  _extends3 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends3.apply(this, arguments);
}
var svgSize = 32;
var strokeWidth = 5;
var radius = (svgSize - strokeWidth) / 2;
var circumference = Math.PI * 2 * radius;
var gap = circumference / 12;
var nSegments = 3;
var segment = circumference / nSegments;
var baseOffset = 2 * circumference / 3 - (segment - gap) / 2;
var circleProps = {
  fill: "none",
  strokeLinecap: "round",
  cx: svgSize / 2,
  cy: svgSize / 2,
  r: radius,
  strokeWidth,
  strokeDasharray: `${segment - gap} ${2 * segment + gap}`
};
var InvitationStatusAvatar = ({ size = 10, status, haltedAt, slots = {}, invitationId }) => {
  var _a;
  const resolvedColor = resolvedStrokeColor(status);
  const halted = status === Invitation3.State.CANCELLED || status === Invitation3.State.TIMEOUT || status === Invitation3.State.ERROR;
  const cursor = invitationStatusValue.get(halted ? haltedAt : status);
  return /* @__PURE__ */ React8.createElement("div", {
    className: "inline-block relative"
  }, /* @__PURE__ */ React8.createElement(InvitationEmoji, _extends3({}, {
    invitationId
  }, {
    size: "sm",
    className: "absolute inset-0 text-base"
  })), /* @__PURE__ */ React8.createElement("svg", _extends3({}, slots.svg, {
    viewBox: `0 0 ${svgSize} ${svgSize}`,
    className: mx4(getSize3(size), (_a = slots.svg) == null ? void 0 : _a.className)
  }), [
    ...Array(nSegments)
  ].map((_, index) => /* @__PURE__ */ React8.createElement("circle", _extends3({
    key: index
  }, circleProps, {
    strokeDashoffset: index * segment + baseOffset,
    className: index === 0 ? cursor === 1 ? halted ? resolvedColor : activeStrokeColor : cursor > 1 ? resolvedColor : inactiveStrokeColor : index === 1 ? cursor === 3 ? halted ? resolvedColor : activeStrokeColor : cursor > 3 ? resolvedColor : inactiveStrokeColor : cursor > 3 ? resolvedColor : inactiveStrokeColor
  })))));
};

// packages/apps/patterns/react-ui/src/components/InvitationList/InvitationListItem.tsx
import { ProhibitInset, QrCode, X } from "@phosphor-icons/react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { QRCodeSVG } from "qrcode.react";
import React9, { useCallback as useCallback2 } from "react";
import { useInvitationStatus } from "@dxos/react-client";
import { Button as Button2, getSize as getSize4, mx as mx5, useId, useTranslation as useTranslation3 } from "@dxos/react-components";
function _extends4() {
  _extends4 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends4.apply(this, arguments);
}
var InvitationListItem = ({ invitation, value, onClickRemove, createInvitationUrl }) => {
  var _a;
  const { t } = useTranslation3("os");
  const qrLabel = useId("qrLabel");
  const { cancel, status, haltedAt, invitationCode, authCode } = useInvitationStatus(invitation);
  const statusValue = (_a = invitationStatusValue.get(status)) != null ? _a : 0;
  const isCancellable = statusValue < 5 && statusValue >= 0;
  const showShare = statusValue < 3 && statusValue >= 0;
  const showAuthCode = statusValue === 3;
  const handleClickRemove = useCallback2(() => onClickRemove(invitation), [
    invitation,
    onClickRemove
  ]);
  const invitationUrl = invitationCode && createInvitationUrl(invitationCode);
  return /* @__PURE__ */ React9.createElement(AccordionPrimitive.Item, {
    value
  }, /* @__PURE__ */ React9.createElement(AccordionPrimitive.Header, {
    className: "flex gap-2 items-center"
  }, /* @__PURE__ */ React9.createElement(InvitationStatusAvatar, _extends4({}, {
    status,
    haltedAt,
    size: 8,
    invitationId: invitation == null ? void 0 : invitation.get().invitationId
  })), showShare && invitationUrl ? /* @__PURE__ */ React9.createElement(React9.Fragment, null, /* @__PURE__ */ React9.createElement(AccordionPrimitive.Trigger, {
    asChild: true
  }, /* @__PURE__ */ React9.createElement(Button2, {
    className: "grow flex gap-1",
    "data-testid": "show-qrcode"
  }, /* @__PURE__ */ React9.createElement("span", null, t("open share panel label")), /* @__PURE__ */ React9.createElement(QrCode, {
    className: getSize4(4),
    weight: "bold"
  }))), /* @__PURE__ */ React9.createElement(CopyButton, {
    value: invitationUrl
  })) : showAuthCode ? /* @__PURE__ */ React9.createElement("p", {
    className: "grow text-xl text-center text-success-500 dark:text-success-300 font-mono"
  }, authCode) : /* @__PURE__ */ React9.createElement("span", {
    role: "none",
    className: "grow"
  }), isCancellable ? /* @__PURE__ */ React9.createElement(Button2, {
    variant: "ghost",
    className: "flex gap-1",
    onClick: cancel,
    "data-testid": "cancel-invitation"
  }, /* @__PURE__ */ React9.createElement("span", {
    className: "sr-only"
  }, t("cancel invitation label")), /* @__PURE__ */ React9.createElement(ProhibitInset, {
    className: getSize4(4),
    weight: "bold"
  })) : /* @__PURE__ */ React9.createElement(Button2, {
    variant: "ghost",
    className: "flex gap-1",
    onClick: handleClickRemove,
    "data-testid": "remove-invitation"
  }, /* @__PURE__ */ React9.createElement("span", {
    className: "sr-only"
  }, t("remove invitation label")), /* @__PURE__ */ React9.createElement(X, {
    className: getSize4(4),
    weight: "bold"
  }))), showShare && invitationUrl && /* @__PURE__ */ React9.createElement(AccordionPrimitive.Content, {
    className: "flex gap-2 is-full radix-state-open:p-1 items-center"
  }, /* @__PURE__ */ React9.createElement(QRCodeSVG, {
    bgColor: "transparent",
    fgColor: "currentColor",
    value: invitationUrl,
    className: mx5("grow-[2] aspect-square is-24 bs-auto"),
    "aria-labelledby": qrLabel
  }), /* @__PURE__ */ React9.createElement("span", {
    className: "pli-1 flex-1 font-system-normal text-sm text-center",
    id: qrLabel
  }, t("qr label"))));
};

// packages/apps/patterns/react-ui/src/components/InvitationList/InvitationListContainer.tsx
import React11, { useCallback as useCallback3 } from "react";
import { useSpace, useSpaceInvitations } from "@dxos/react-client";

// packages/apps/patterns/react-ui/src/components/InvitationList/InvitationList.tsx
import { Root as AccordionRoot } from "@radix-ui/react-accordion";
import React10 from "react";
import { defaultDescription, DensityProvider, mx as mx6, useTranslation as useTranslation4 } from "@dxos/react-components";
function _extends5() {
  _extends5 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends5.apply(this, arguments);
}
var InvitationList = ({ invitations, ...invitationProps }) => {
  const { t } = useTranslation4("os");
  return invitations.length ? /* @__PURE__ */ React10.createElement(AccordionRoot, {
    type: "single",
    collapsible: true,
    className: "flex flex-col gap-1"
  }, /* @__PURE__ */ React10.createElement(DensityProvider, {
    density: "fine"
  }, /* @__PURE__ */ React10.createElement(ClipboardProvider, null, invitations.map((invitation) => {
    const value = invitation.get().invitationId;
    return /* @__PURE__ */ React10.createElement(InvitationListItem, _extends5({
      key: value,
      value,
      invitation
    }, invitationProps));
  })))) : /* @__PURE__ */ React10.createElement("p", {
    className: mx6(defaultDescription, "text-center p-2")
  }, t("empty invitations message"));
};

// packages/apps/patterns/react-ui/src/components/InvitationList/InvitationListContainer.tsx
function _extends6() {
  _extends6 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends6.apply(this, arguments);
}
var InvitationListContainer = ({ spaceKey, createInvitationUrl }) => {
  const space = useSpace(spaceKey);
  const invitations = useSpaceInvitations(spaceKey);
  const onClickRemove = useCallback3((invitation) => {
    const invitationId = invitation.get().invitationId;
    invitationId && (space == null ? void 0 : space.removeInvitation(invitationId));
  }, [
    space
  ]);
  return /* @__PURE__ */ React11.createElement(InvitationList, _extends6({
    invitations
  }, {
    onClickRemove,
    createInvitationUrl
  }));
};

// packages/apps/patterns/react-ui/src/components/PanelSeparator/PanelSeparator.tsx
import React12 from "react";
import { mx as mx7 } from "@dxos/react-components";
function _extends7() {
  _extends7 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends7.apply(this, arguments);
}
var PanelSeparator = ({ className, ...props }) => {
  return /* @__PURE__ */ React12.createElement("span", _extends7({
    role: "none"
  }, props, {
    className: mx7("block bs-px mlb-1 bg-neutral-800/10 dark:bg-neutral-200/10", className)
  }));
};

// packages/apps/patterns/react-ui/src/components/SpaceList/SpaceListItem.tsx
import React13, { forwardRef } from "react";
import { Avatar as Avatar2, mx as mx8 } from "@dxos/react-components";
import { humanize } from "@dxos/util";
function _extends8() {
  _extends8 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends8.apply(this, arguments);
}
var SpaceListItem = /* @__PURE__ */ forwardRef(({ space, onClick }, ref) => {
  var _a;
  return /* @__PURE__ */ React13.createElement("li", {
    className: mx8("flex gap-2 items-center mbe-2", onClick && "cursor-pointer"),
    onClick: () => onClick == null ? void 0 : onClick(),
    ref,
    "data-testid": "space-list-item"
  }, /* @__PURE__ */ React13.createElement(Avatar2, _extends8({}, {
    variant: "circle",
    size: 9,
    fallbackValue: space.key.toHex(),
    label: /* @__PURE__ */ React13.createElement("p", {
      className: "text-sm truncate"
    }, (_a = space.properties.name) != null ? _a : humanize(space.key)),
    slots: {
      labels: {
        className: "block shrink overflow-hidden"
      },
      root: {
        className: "shrink-0"
      }
    }
  })));
});

// packages/apps/patterns/react-ui/src/composites/IdentityPopover/IdentityPopover.tsx
import React31 from "react";
import { Avatar as Avatar5, mx as mx23 } from "@dxos/react-components";

// packages/apps/patterns/react-ui/src/layouts/PanelPopover/PanelPopover.tsx
import React14 from "react";
import { mx as mx9, Popover } from "@dxos/react-components";
function _extends9() {
  _extends9 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends9.apply(this, arguments);
}
var PanelPopover = ({ slots, children, ...popoverProps }) => {
  var _a, _b, _c;
  return /* @__PURE__ */ React14.createElement(Popover, _extends9({
    slots: {
      arrow: {
        ...slots == null ? void 0 : slots.arrow,
        className: mx9(defaultArrow, (_a = slots == null ? void 0 : slots.arrow) == null ? void 0 : _a.className)
      },
      content: {
        collisionPadding: 8,
        sideOffset: 4,
        ...slots == null ? void 0 : slots.content,
        className: mx9(defaultSurface, (_b = slots == null ? void 0 : slots.content) == null ? void 0 : _b.className)
      },
      trigger: {
        ...slots == null ? void 0 : slots.trigger,
        className: mx9("", (_c = slots == null ? void 0 : slots.trigger) == null ? void 0 : _c.className)
      },
      ...slots
    }
  }, popoverProps), children);
};

// packages/apps/patterns/react-ui/src/layouts/PanelSidebar/PanelSidebar.tsx
import * as DialogPrimitive from "@radix-ui/react-dialog";
import React15, { createContext as createContext2, useCallback as useCallback4, useContext as useContext2, useState as useState2 } from "react";
import { defaultOverlay as defaultOverlay2, mx as mx10, useMediaQuery, useTranslation as useTranslation5 } from "@dxos/react-components";
function _extends10() {
  _extends10 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends10.apply(this, arguments);
}
var PanelSidebarContext = /* @__PURE__ */ createContext2({
  displayState: "hide",
  setDisplayState: () => {
  }
});
var useTogglePanelSidebar = () => {
  const { displayState, setDisplayState } = useContext2(PanelSidebarContext);
  return useCallback4(() => {
    setDisplayState(displayState === "hide" ? "show" : "hide");
  }, [
    displayState
  ]);
};
var PanelSidebarProvider = ({ children, slots }) => {
  var _a, _b, _c;
  const { t } = useTranslation5("os");
  const [isLg] = useMediaQuery("lg", {
    ssr: false
  });
  const [displayState, setInternalDisplayState] = useState2(isLg ? "show" : "hide");
  const isOpen = displayState === "show";
  const [transitionShow, setTransitionShow] = useState2(isOpen);
  const [domShow, setDomShow] = useState2(isOpen);
  const internalHide = () => {
    setTransitionShow(false);
    setInternalDisplayState("hide");
    setTimeout(() => {
      setDomShow(false);
    }, 200);
  };
  const internalShow = () => {
    setDomShow(true);
    setInternalDisplayState("show");
    setTimeout(() => {
      setTransitionShow(true);
    }, 0);
  };
  const setDisplayState = (displayState2) => displayState2 === "show" ? internalShow() : internalHide();
  return /* @__PURE__ */ React15.createElement(PanelSidebarContext.Provider, {
    value: {
      setDisplayState,
      displayState
    }
  }, /* @__PURE__ */ React15.createElement(DialogPrimitive.Root, {
    open: domShow,
    modal: !isLg
  }, /* @__PURE__ */ React15.createElement(DialogPrimitive.Content, _extends10({
    onOpenAutoFocus: (event) => isLg && event.preventDefault(),
    onCloseAutoFocus: (event) => isLg && event.preventDefault()
  }, slots == null ? void 0 : slots.content, {
    className: mx10("fixed block-start-0 block-end-0 is-sidebar z-30 overscroll-contain overflow-x-hidden overflow-y-auto", "transition-[inset-inline-start,inset-inline-end] duration-200 ease-in-out", transitionShow ? "inline-start-0" : "-inline-start-sidebar", (_a = slots == null ? void 0 : slots.content) == null ? void 0 : _a.className)
  }), /* @__PURE__ */ React15.createElement(DialogPrimitive.Title, {
    className: "sr-only"
  }, t("sidebar label")), (_b = slots == null ? void 0 : slots.content) == null ? void 0 : _b.children), !isLg && /* @__PURE__ */ React15.createElement(DialogPrimitive.Overlay, {
    className: mx10(defaultOverlay2, "transition-opacity duration-200 ease-in-out", transitionShow ? "opacity-100" : "opacity-0"),
    onClick: internalHide
  }), /* @__PURE__ */ React15.createElement("div", _extends10({
    role: "none"
  }, slots == null ? void 0 : slots.main, {
    className: mx10("transition-[padding-inline-start] duration-200 ease-in-out", isLg && isOpen ? "pis-sidebar" : "pis-0", (_c = slots == null ? void 0 : slots.main) == null ? void 0 : _c.className)
  }), children)));
};

// packages/apps/patterns/react-ui/src/layouts/PanelAlertDialog/PanelAlertDialog.tsx
import * as AlertDialog from "@radix-ui/react-alert-dialog";
import React16 from "react";
import { mx as mx11 } from "@dxos/react-components";
function _extends11() {
  _extends11 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends11.apply(this, arguments);
}
var PanelAlertDialog = ({ titleId, slots = {}, children }) => {
  var _a, _b;
  return /* @__PURE__ */ React16.createElement(AlertDialog.Root, _extends11({
    defaultOpen: true
  }, slots.root), slots.trigger && /* @__PURE__ */ React16.createElement(AlertDialog.Trigger, _extends11({}, slots.trigger)), /* @__PURE__ */ React16.createElement(AlertDialog.Overlay, _extends11({}, slots.overlay, {
    className: mx11(defaultOverlay, "z-40", (_a = slots.overlay) == null ? void 0 : _a.className)
  }), /* @__PURE__ */ React16.createElement(AlertDialog.Content, _extends11({
    onEscapeKeyDown: (event) => event.preventDefault()
  }, slots.content, {
    "aria-labelledby": titleId,
    className: mx11(defaultDialogContent, (_b = slots.content) == null ? void 0 : _b.className)
  }), children)));
};

// packages/apps/patterns/react-ui/src/layouts/PanelDialog/PanelDialog.tsx
import * as Dialog from "@radix-ui/react-dialog";
import React17 from "react";
import { mx as mx12 } from "@dxos/react-components";
function _extends12() {
  _extends12 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends12.apply(this, arguments);
}
var PanelDialog = ({ titleId, slots = {}, children }) => {
  var _a, _b;
  return /* @__PURE__ */ React17.createElement(Dialog.Root, _extends12({
    defaultOpen: true
  }, slots.root), slots.trigger && /* @__PURE__ */ React17.createElement(Dialog.Trigger, _extends12({}, slots.trigger)), /* @__PURE__ */ React17.createElement(Dialog.Overlay, _extends12({}, slots.overlay, {
    className: mx12(defaultOverlay, "z-40", (_a = slots.overlay) == null ? void 0 : _a.className)
  }), /* @__PURE__ */ React17.createElement(Dialog.Content, _extends12({
    onOpenAutoFocus: (event) => event.preventDefault(),
    onCloseAutoFocus: (event) => event.preventDefault()
  }, slots.content, {
    "aria-labelledby": titleId,
    className: mx12(defaultDialogContent, (_b = slots.content) == null ? void 0 : _b.className)
  }), children)));
};

// packages/apps/patterns/react-ui/src/panels/DevicesPanel/DevicesPanel.tsx
import { UserPlus, X as X2 } from "@phosphor-icons/react";
import React18, { cloneElement, useReducer } from "react";
import { useClient as useClient2, useDevices, useHaloInvitations, useIdentity } from "@dxos/react-client";
import { Button as Button3, DensityProvider as DensityProvider2, getSize as getSize5, mx as mx13, TooltipContent, TooltipRoot, TooltipTrigger, useTranslation as useTranslation6 } from "@dxos/react-components";
function _extends13() {
  _extends13 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends13.apply(this, arguments);
}
var DeviceListView = ({ createInvitationUrl, titleId, onDone, doneActionParent }) => {
  var _a;
  const { t } = useTranslation6("os");
  const client = useClient2();
  const identity = useIdentity();
  const devices = useDevices();
  const invitations = useHaloInvitations();
  const displayName = (_a = identity == null ? void 0 : identity.profile) == null ? void 0 : _a.displayName;
  if (!identity) {
    return null;
  }
  const doneButton = /* @__PURE__ */ React18.createElement(Button3, {
    variant: "ghost",
    onClick: () => onDone == null ? void 0 : onDone(),
    "data-testid": "show-all-spaces"
  }, /* @__PURE__ */ React18.createElement(X2, {
    className: getSize5(4),
    weight: "bold"
  }));
  return /* @__PURE__ */ React18.createElement("div", {
    role: "none",
    className: "flex flex-col"
  }, /* @__PURE__ */ React18.createElement("div", {
    role: "none",
    className: mx13(subduedSurface, "rounded-bs-md flex items-center p-2 gap-2")
  }, /* @__PURE__ */ React18.createElement("h2", {
    id: titleId,
    className: mx13("grow font-system-medium", !displayName && "font-mono")
  }, displayName != null ? displayName : identity.identityKey.truncate()), /* @__PURE__ */ React18.createElement(TooltipRoot, null, /* @__PURE__ */ React18.createElement(TooltipContent, {
    className: "z-50"
  }, t("close label")), /* @__PURE__ */ React18.createElement(TooltipTrigger, {
    asChild: true
  }, doneActionParent ? /* @__PURE__ */ cloneElement(doneActionParent, {}, doneButton) : doneButton))), /* @__PURE__ */ React18.createElement("div", {
    role: "region",
    className: mx13(defaultSurface, "rounded-be-md p-2")
  }, /* @__PURE__ */ React18.createElement(InvitationList, {
    invitations,
    onClickRemove: (invitation) => invitation.get() && client.halo.removeInvitation(invitation.get().invitationId),
    createInvitationUrl
  }), /* @__PURE__ */ React18.createElement(Button3, {
    className: "is-full flex gap-2 mbs-2",
    onClick: () => client.halo.createInvitation(),
    "data-testid": "devices-panel.create-invitation"
  }, /* @__PURE__ */ React18.createElement("span", null, t("create device invitation label")), /* @__PURE__ */ React18.createElement(UserPlus, {
    className: getSize5(4),
    weight: "bold"
  })), /* @__PURE__ */ React18.createElement(PanelSeparator, null), /* @__PURE__ */ React18.createElement(DeviceList, {
    devices
  })));
};
var DevicesPanel = (props) => {
  const reducer = (state, action) => {
    const nextState = {
      ...state
    };
    switch (action.type) {
      case null:
    }
    return nextState;
  };
  const [panelState] = useReducer(reducer, {
    activeView: "device list"
  });
  return /* @__PURE__ */ React18.createElement(DensityProvider2, {
    density: "fine"
  }, panelState.activeView === "device list" ? /* @__PURE__ */ React18.createElement(DeviceListView, _extends13({}, props)) : null);
};

// packages/apps/patterns/react-ui/src/panels/IdentityPanel/IdentityPanel.tsx
import React19 from "react";
import { useClient as useClient3 } from "@dxos/react-client";
import { Avatar as Avatar3, Button as Button4, DensityProvider as DensityProvider3, ThemeContext, useThemeContext, useTranslation as useTranslation7 } from "@dxos/react-components";
var IdentityPanel = ({ identity, onClickManageProfile }) => {
  var _a, _b;
  const { t } = useTranslation7("os");
  const client = useClient3();
  const themeContextValue = useThemeContext();
  const defaultManageProfile = () => {
    const remoteSource = new URL((client == null ? void 0 : client.config.get("runtime.client.remoteSource")) || "https://halo.dxos.org");
    const tab = window.open(remoteSource.origin, "_blank");
    tab == null ? void 0 : tab.focus();
  };
  return /* @__PURE__ */ React19.createElement(ThemeContext.Provider, {
    value: {
      ...themeContextValue,
      themeVariant: "os"
    }
  }, /* @__PURE__ */ React19.createElement(DensityProvider3, {
    density: "fine"
  }, /* @__PURE__ */ React19.createElement("div", {
    className: "flex flex-col gap-2 justify-center items-center"
  }, /* @__PURE__ */ React19.createElement(Avatar3, {
    size: 16,
    variant: "circle",
    fallbackValue: identity.identityKey.toHex(),
    label: (_b = (_a = identity.profile) == null ? void 0 : _a.displayName) != null ? _b : ""
  }), /* @__PURE__ */ React19.createElement(Button4, {
    onClick: onClickManageProfile != null ? onClickManageProfile : defaultManageProfile,
    className: "is-full"
  }, t("manage profile label")))));
};

// packages/apps/patterns/react-ui/src/panels/JoinPanel/JoinPanel.tsx
import React29, { useEffect as useEffect2 } from "react";
import { log as log2 } from "@dxos/log";
import { useClient as useClient5, useIdentity as useIdentity2 } from "@dxos/react-client";
import { DensityProvider as DensityProvider4, useId as useId4, useThemeContext as useThemeContext2 } from "@dxos/react-components";

// packages/apps/patterns/react-ui/src/panels/JoinPanel/JoinHeading.tsx
import { X as X3 } from "@phosphor-icons/react";
import React20, { cloneElement as cloneElement2, forwardRef as forwardRef2 } from "react";
import { useSpace as useSpace2 } from "@dxos/react-client";
import { Button as Button5, defaultDescription as defaultDescription2, getSize as getSize6, Heading, mx as mx14, useId as useId2, useTranslation as useTranslation8 } from "@dxos/react-components";
function _extends14() {
  _extends14 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends14.apply(this, arguments);
}
var JoinHeading = /* @__PURE__ */ forwardRef2(({ mode, titleId, joinState, onExit, exitActionParent, preventExit }, ref) => {
  var _a, _b;
  const { t } = useTranslation8("os");
  const space = useSpace2((_a = joinState == null ? void 0 : joinState.context.space.invitation) == null ? void 0 : _a.spaceKey);
  const name = space == null ? void 0 : space.properties.name;
  const nameId = useId2(mode === "halo-only" ? "identityDisplayName" : "spaceDisplayName");
  const invitationId = (_b = joinState == null ? void 0 : joinState.context[mode === "halo-only" ? "halo" : "space"].invitation) == null ? void 0 : _b.invitationId;
  const exitButton = /* @__PURE__ */ React20.createElement(Button5, _extends14({
    variant: "ghost"
  }, onExit && {
    onClick: onExit
  }, {
    className: mx14(defaultDescription2, "plb-0 pli-2 absolute block-start-1.5 inline-end-2 z-[1]"),
    "data-testid": "join-exit"
  }), /* @__PURE__ */ React20.createElement(X3, {
    weight: "bold",
    className: getSize6(4)
  }), /* @__PURE__ */ React20.createElement("span", {
    className: "sr-only"
  }, t("exit label")));
  return /* @__PURE__ */ React20.createElement("div", {
    role: "none",
    className: mx14(defaultSurface, "pbs-3 pbe-1 rounded-bs-md relative"),
    ref
  }, !preventExit && mode !== "halo-only" && (exitActionParent ? /* @__PURE__ */ cloneElement2(exitActionParent, {}, exitButton) : exitButton), /* @__PURE__ */ React20.createElement(Heading, {
    level: 1,
    className: mx14(defaultDescription2, "font-body font-system-normal text-center text-sm grow pbe-2", mode === "halo-only" && (preventExit ? "sr-only" : "opacity-0")),
    id: titleId
  }, t(mode === "halo-only" ? "selecting identity heading" : "joining space heading")), /* @__PURE__ */ React20.createElement("div", {
    role: "group",
    className: "flex items-center justify-center gap-2"
  }, /* @__PURE__ */ React20.createElement(InvitationEmoji, _extends14({}, {
    invitationId
  })), name && /* @__PURE__ */ React20.createElement("p", {
    id: nameId
  }, name)));
});

// packages/apps/patterns/react-ui/src/panels/JoinPanel/joinMachine.ts
import { useMachine } from "@xstate/react";
import { useCallback as useCallback5 } from "react";
import { assign, createMachine } from "xstate";
import { Invitation as Invitation4, InvitationEncoder } from "@dxos/client";
import { log } from "@dxos/log";
var getInvitationSubscribable = (Kind, invitation) => {
  log("[subscribing to invitation]", invitation, {
    file: "joinMachine.ts",
    line: 77,
    scope: void 0,
    callSite: (f, a) => f(...a)
  });
  return {
    subscribe: (next, onError, complete) => invitation.subscribe((invitation2) => {
      switch (invitation2.state) {
        case Invitation4.State.CONNECTING: {
          log("[invitation connecting]", {
            Kind,
            invitation: invitation2
          }, {
            file: "joinMachine.ts",
            line: 88,
            scope: void 0,
            callSite: (f, a) => f(...a)
          });
          return next({
            type: `connecting${Kind}Invitation`,
            invitation: invitation2
          });
        }
        case Invitation4.State.CONNECTED: {
          log("[invitation connected]", {
            Kind,
            invitation: invitation2
          }, {
            file: "joinMachine.ts",
            line: 93,
            scope: void 0,
            callSite: (f, a) => f(...a)
          });
          return next({
            type: `connected${Kind}Invitation`,
            invitation: invitation2
          });
        }
        case Invitation4.State.READY_FOR_AUTHENTICATION: {
          log("[invitation ready for authentication]", {
            Kind,
            invitation: invitation2
          }, {
            file: "joinMachine.ts",
            line: 98,
            scope: void 0,
            callSite: (f, a) => f(...a)
          });
          return next({
            type: `readyForAuthentication${Kind}Invitation`,
            invitation: invitation2
          });
        }
        case Invitation4.State.AUTHENTICATING: {
          log("[invitation authenticating]", {
            Kind,
            invitation: invitation2
          }, {
            file: "joinMachine.ts",
            line: 103,
            scope: void 0,
            callSite: (f, a) => f(...a)
          });
          return next({
            type: `authenticating${Kind}Invitation`,
            invitation: invitation2
          });
        }
        case Invitation4.State.SUCCESS: {
          log("[invitation success]", {
            Kind,
            invitation: invitation2
          }, {
            file: "joinMachine.ts",
            line: 108,
            scope: void 0,
            callSite: (f, a) => f(...a)
          });
          next({
            type: `success${Kind}Invitation`,
            invitation: invitation2
          });
          return complete == null ? void 0 : complete();
        }
        case Invitation4.State.CANCELLED: {
          log.warn("[invitation cancelled]", {
            Kind
          }, {
            file: "joinMachine.ts",
            line: 114,
            scope: void 0,
            callSite: (f, a) => f(...a)
          });
          return next({
            type: `fail${Kind}Invitation`,
            reason: "cancelled"
          });
        }
        case Invitation4.State.TIMEOUT: {
          log.error("[invitation timeout]", {
            Kind
          }, {
            file: "joinMachine.ts",
            line: 119,
            scope: void 0,
            callSite: (f, a) => f(...a)
          });
          return next({
            type: `fail${Kind}Invitation`,
            reason: "timeout"
          });
        }
      }
    }, (error) => {
      log.error("[invitation errored]", {
        Kind,
        error
      }, {
        file: "joinMachine.ts",
        line: 125,
        scope: void 0,
        callSite: (f, a) => f(...a)
      });
      next({
        type: `fail${Kind}Invitation`,
        reason: "error"
      });
      return onError == null ? void 0 : onError(error);
    })
  };
};
var acceptingInvitationTemplate = (Kind, successTarget) => {
  const config = {
    initial: `unknown${Kind}`,
    states: {
      [`unknown${Kind}`]: {
        always: [
          {
            cond: ({ mode }) => mode === "halo-only" && Kind === "Space",
            target: "#join.finishingJoiningHalo"
          },
          {
            // cond: `no${Kind}Invitation`,
            target: `inputting${Kind}InvitationCode`,
            actions: "log"
          }
        ]
      },
      [`inputting${Kind}InvitationCode`]: {},
      [`acceptingRedeemed${Kind}Invitation`]: {
        invoke: {
          src: (context) => context[Kind.toLowerCase()].invitationSubscribable
        },
        initial: `unknown${Kind}Invitation`,
        states: {
          [`unknown${Kind}Invitation`]: {
            always: [
              {
                cond: (context) => {
                  const invitation = context[Kind.toLowerCase()].invitation;
                  return !invitation || (invitation == null ? void 0 : invitation.state) === Invitation4.State.CONNECTING;
                },
                target: `connecting${Kind}Invitation`,
                actions: "log"
              },
              {
                target: `inputting${Kind}VerificationCode`,
                actions: "log"
              }
            ]
          },
          [`connecting${Kind}Invitation`]: {},
          [`inputting${Kind}VerificationCode`]: {},
          [`authenticating${Kind}VerificationCode`]: {
            on: {
              [`readyForAuthentication${Kind}Invitation`]: {
                target: `authenticationFailing${Kind}VerificationCode`,
                actions: [
                  "setInvitation",
                  "log"
                ]
              }
            }
          },
          [`authenticationFailing${Kind}VerificationCode`]: {},
          [`failing${Kind}Invitation`]: {},
          [`success${Kind}Invitation`]: {}
        },
        on: {
          [`reset${Kind}Invitation`]: {
            target: `#join${Kind === "Halo" ? ".choosingIdentity" : ""}.accepting${Kind}Invitation.unknown${Kind}`,
            actions: [
              "resetInvitation",
              "log"
            ]
          },
          [`connecting${Kind}Invitation`]: {
            target: `.connecting${Kind}Invitation`,
            actions: [
              "setInvitation",
              "log"
            ]
          },
          [`connected${Kind}Invitation`]: {
            target: `.connecting${Kind}Invitation`,
            actions: [
              "setInvitation",
              "log"
            ]
          },
          [`readyForAuthentication${Kind}Invitation`]: {
            target: `.inputting${Kind}VerificationCode`,
            actions: [
              "setInvitation",
              "log"
            ]
          },
          [`authenticating${Kind}Invitation`]: {
            target: `.authenticating${Kind}VerificationCode`,
            actions: [
              "setInvitation",
              "log"
            ]
          },
          [`success${Kind}Invitation`]: {
            target: successTarget,
            actions: [
              "setInvitation",
              "log"
            ]
          },
          [`fail${Kind}Invitation`]: {
            target: `.failing${Kind}Invitation`,
            actions: [
              assign({
                [Kind.toLowerCase()]: (context, event) => ({
                  ...context[Kind.toLowerCase()],
                  failReason: event.reason
                })
              }),
              "log"
            ]
          }
        }
      }
    },
    on: {
      [`set${Kind}InvitationCode`]: {
        target: `.acceptingRedeemed${Kind}Invitation`,
        actions: [
          assign({
            [Kind.toLowerCase()]: (context, event) => ({
              ...context[Kind.toLowerCase()],
              unredeemedCode: event.code
            })
          }),
          `redeem${Kind}InvitationCode`,
          "log"
        ]
      }
    }
  };
  return config;
};
var joinMachine = createMachine({
  id: "join",
  predictableActionArguments: true,
  context: {
    mode: "default",
    identity: null,
    halo: {},
    space: {}
  },
  initial: "unknown",
  states: {
    unknown: {
      always: [
        {
          cond: "noSelectedIdentity",
          target: "choosingIdentity",
          actions: "log"
        },
        {
          target: "acceptingSpaceInvitation",
          actions: "log"
        }
      ]
    },
    choosingIdentity: {
      initial: "choosingAuthMethod",
      states: {
        choosingAuthMethod: {},
        recoveringIdentity: {},
        creatingIdentity: {},
        acceptingHaloInvitation: acceptingInvitationTemplate("Halo", "#join.acceptingSpaceInvitation"),
        confirmingAddedIdentity: {}
      },
      on: {
        recoverIdentity: {
          target: ".recoveringIdentity",
          actions: "log"
        },
        createIdentity: {
          target: ".creatingIdentity",
          actions: "log"
        },
        acceptHaloInvitation: {
          target: ".acceptingHaloInvitation",
          actions: "log"
        },
        addIdentity: {
          target: ".confirmingAddedIdentity",
          actions: "log"
        },
        selectIdentity: {
          target: "acceptingSpaceInvitation",
          actions: [
            "setIdentity",
            "log"
          ]
        },
        deselectAuthMethod: {
          target: ".choosingAuthMethod",
          actions: "log"
        }
      }
    },
    acceptingSpaceInvitation: acceptingInvitationTemplate("Space", "#join.finishingJoiningSpace"),
    finishingJoiningSpace: {
      type: "final"
    },
    finishingJoiningHalo: {
      type: "final"
    }
  }
}, {
  guards: {
    noSelectedIdentity: ({ identity }, _event) => !identity,
    noHaloInvitation: ({ halo }, _event) => !halo.invitation && !halo.unredeemedCode,
    noSpaceInvitation: ({ space }, _event) => !space.invitation && !space.unredeemedCode
  },
  actions: {
    setIdentity: assign({
      identity: (context, event) => event.identity
    }),
    unsetIdentity: assign({
      identity: () => null
    }),
    resetInvitation: assign({
      halo: (context, event) => event.type === "resetHaloInvitation" ? {
        ...context.halo,
        invitation: void 0,
        invitationObservable: void 0,
        invitationSubscribable: void 0
      } : context.halo,
      space: (context, event) => event.type === "resetSpaceInvitation" ? {
        ...context.space,
        invitation: void 0,
        invitationObservable: void 0,
        invitationSubscribable: void 0
      } : context.space
    }),
    setInvitation: assign({
      halo: (context, event) => event.type.includes("Halo") ? {
        ...context.halo,
        invitation: event.invitation
      } : context.halo,
      space: (context, event) => event.type.includes("Space") ? {
        ...context.space,
        invitation: event.invitation
      } : context.space
    }),
    log: (context, event) => {
      log("[transition]", {
        event,
        haloInvitation: context.halo.invitation,
        spaceInvitation: context.space.invitation
      }, {
        file: "joinMachine.ts",
        line: 351,
        scope: void 0,
        callSite: (f, a) => f(...a)
      });
    }
  }
});
var defaultCodeFromUrl = (invitationType, text) => {
  var _a, _b, _c, _d;
  try {
    const searchParams = new URLSearchParams(text.substring(text.lastIndexOf("?")));
    return (_d = (_c = (_b = (_a = searchParams.get(`${invitationType}InvitationCode`)) != null ? _a : searchParams.get(`${invitationType}Invitation`)) != null ? _b : searchParams.get("invitationCode")) != null ? _c : searchParams.get("invitation")) != null ? _d : text;
  } catch (err) {
    log.catch(err, {}, {
      file: "joinMachine.ts",
      line: 377,
      scope: void 0,
      callSite: (f, a) => f(...a)
    });
    return text;
  }
};
var useJoinMachine = (client, options) => {
  const redeemHaloInvitationCode = useCallback5(({ halo }) => {
    if (halo.unredeemedCode) {
      const invitationObservable = client.halo.acceptInvitation(InvitationEncoder.decode(defaultCodeFromUrl("halo", halo.unredeemedCode)));
      return {
        ...halo,
        invitationObservable,
        invitationSubscribable: getInvitationSubscribable("Halo", invitationObservable)
      };
    } else {
      return halo;
    }
  }, [
    client
  ]);
  const redeemSpaceInvitationCode = useCallback5(({ space }) => {
    if (space.unredeemedCode) {
      const invitationObservable = client.acceptInvitation(InvitationEncoder.decode(defaultCodeFromUrl("space", space.unredeemedCode)));
      return {
        ...space,
        invitationObservable,
        invitationSubscribable: getInvitationSubscribable("Space", invitationObservable)
      };
    } else {
      return space;
    }
  }, [
    client
  ]);
  return useMachine(joinMachine, {
    ...options,
    actions: {
      ...options == null ? void 0 : options.actions,
      redeemHaloInvitationCode: assign({
        halo: redeemHaloInvitationCode
      }),
      redeemSpaceInvitationCode: assign({
        space: redeemSpaceInvitationCode
      })
    }
  });
};

// packages/apps/patterns/react-ui/src/panels/JoinPanel/view-states/AdditionMethodSelector.tsx
import { CaretRight, Plus, QrCode as QrCode2, Textbox } from "@phosphor-icons/react";
import React22 from "react";
import { CompoundButton, getSize as getSize8, useTranslation as useTranslation10 } from "@dxos/react-components";

// packages/apps/patterns/react-ui/src/panels/JoinPanel/view-states/ViewState.tsx
import { CheckCircle, HourglassSimple, X as X4 } from "@phosphor-icons/react";
import React21, { useMemo as useMemo2 } from "react";
import { Invitation as Invitation5 } from "@dxos/client";
import { useInvitationStatus as useInvitationStatus2 } from "@dxos/react-client";
import { mx as mx15, useTranslation as useTranslation9, useId as useId3, getSize as getSize7, strongShimmer } from "@dxos/react-components";
function _extends15() {
  _extends15 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends15.apply(this, arguments);
}
var stripe = mx15("rounded-full grow", getSize7(3));
var ViewStateHeading = ({ children, className, ...props }) => {
  return /* @__PURE__ */ React21.createElement("h2", _extends15({}, props, {
    className: mx15("font-system-normal text-sm mbe-1 mli-1 text-center", className)
  }), children);
};
var ViewState = ({ active, children, className, joinSend, joinState, ...props }) => {
  return /* @__PURE__ */ React21.createElement("div", _extends15({
    role: "none"
  }, props, !active && {
    "aria-hidden": true
  }, {
    className: mx15("is-[50%] flex flex-col", active ? "order-2" : "order-4", className)
  }), /* @__PURE__ */ React21.createElement("div", {
    role: "region",
    className: mx15(defaultSurface, "rounded-be-md grow shrink-0 flex flex-col gap-1 p-4 pbs-1")
  }, children));
};

// packages/apps/patterns/react-ui/src/panels/JoinPanel/view-states/AdditionMethodSelector.tsx
function _extends16() {
  _extends16 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends16.apply(this, arguments);
}
var AdditionMethodSelector = (viewStateProps) => {
  const disabled = !viewStateProps.active;
  const { joinSend } = viewStateProps;
  const { t } = useTranslation10("os");
  const sharedButtonProps = {
    disabled,
    after: /* @__PURE__ */ React22.createElement(CaretRight, {
      className: getSize8(4),
      weight: "bold"
    }),
    slots: {
      label: {
        className: "text-sm"
      }
    }
  };
  return /* @__PURE__ */ React22.createElement(ViewState, _extends16({}, viewStateProps), /* @__PURE__ */ React22.createElement(ViewStateHeading, null, t("addition method selector title")), /* @__PURE__ */ React22.createElement("div", {
    role: "none",
    className: "flex flex-col gap-1 grow"
  }, /* @__PURE__ */ React22.createElement(CompoundButton, _extends16({}, sharedButtonProps, {
    description: t("create identity description"),
    before: /* @__PURE__ */ React22.createElement(Plus, {
      className: getSize8(6)
    }),
    onClick: () => joinSend({
      type: "createIdentity"
    }),
    "data-autofocus": "choosingAuthMethod",
    "data-testid": "create-identity"
  }), t("create identity label")), /* @__PURE__ */ React22.createElement(CompoundButton, _extends16({}, sharedButtonProps, {
    description: t("join identity description"),
    before: /* @__PURE__ */ React22.createElement(QrCode2, {
      className: getSize8(6)
    }),
    onClick: () => joinSend({
      type: "acceptHaloInvitation"
    }),
    "data-testid": "join-identity"
  }), t("join identity label")), /* @__PURE__ */ React22.createElement(CompoundButton, _extends16({}, sharedButtonProps, {
    // TODO(mykola): Implement recover.
    disabled: true,
    description: t("recover identity description"),
    before: /* @__PURE__ */ React22.createElement(Textbox, {
      className: getSize8(6)
    }),
    onClick: () => joinSend({
      type: "recoverIdentity"
    }),
    "data-testid": "recover-identity"
  }), t("recover identity label"))));
};

// packages/apps/patterns/react-ui/src/panels/JoinPanel/view-states/IdentityAdded.tsx
import { CaretLeft, CaretRight as CaretRight2, Check as Check2 } from "@phosphor-icons/react";
import React23, { cloneElement as cloneElement3 } from "react";
import { Avatar as Avatar4, Button as Button6, getSize as getSize9, mx as mx16, useTranslation as useTranslation11 } from "@dxos/react-components";
function _extends17() {
  _extends17 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends17.apply(this, arguments);
}
var Done = ({ onDone, doneActionParent, active }) => {
  const disabled = !active;
  const { t } = useTranslation11("os");
  const doneButton = /* @__PURE__ */ React23.createElement(Button6, _extends17({}, onDone && {
    onClick: () => onDone(null)
  }, {
    disabled,
    className: "grow flex items-center gap-2 pli-2",
    "data-autofocus": "confirmingAddedIdentity",
    "data-testid": "identity-added-done"
  }), /* @__PURE__ */ React23.createElement(CaretLeft, {
    weight: "bold",
    className: mx16(getSize9(2), "invisible")
  }), /* @__PURE__ */ React23.createElement("span", {
    className: "grow"
  }, t("done label")), /* @__PURE__ */ React23.createElement(Check2, {
    className: getSize9(4)
  }));
  return doneActionParent ? /* @__PURE__ */ cloneElement3(doneActionParent, {}, doneButton) : doneButton;
};
var IdentityAdded = ({ mode, addedIdentity, onDone, doneActionParent, ...viewStateProps }) => {
  var _a, _b, _c, _d, _e;
  const disabled = !viewStateProps.active;
  const { joinSend } = viewStateProps;
  const { t } = useTranslation11("os");
  return /* @__PURE__ */ React23.createElement(ViewState, _extends17({}, viewStateProps), /* @__PURE__ */ React23.createElement(ViewStateHeading, null, t("identity added label")), /* @__PURE__ */ React23.createElement("div", {
    role: "none",
    className: "grow flex flex-col items-center justify-center text-center gap-2"
  }, /* @__PURE__ */ React23.createElement(Avatar4, {
    size: 20,
    fallbackValue: (_a = addedIdentity == null ? void 0 : addedIdentity.identityKey.toHex()) != null ? _a : "",
    label: /* @__PURE__ */ React23.createElement("p", {
      className: mx16("text-lg", !((_b = addedIdentity == null ? void 0 : addedIdentity.profile) == null ? void 0 : _b.displayName) && "font-mono")
    }, (_e = (_d = (_c = addedIdentity == null ? void 0 : addedIdentity.profile) == null ? void 0 : _c.displayName) != null ? _d : addedIdentity == null ? void 0 : addedIdentity.identityKey.truncate()) != null ? _e : "\xA0"),
    variant: "circle",
    status: "active"
  })), mode === "halo-only" ? /* @__PURE__ */ React23.createElement(Done, _extends17({
    onDone,
    doneActionParent
  }, viewStateProps)) : /* @__PURE__ */ React23.createElement("div", {
    className: "flex gap-2"
  }, /* @__PURE__ */ React23.createElement(Button6, {
    disabled: disabled || !addedIdentity,
    className: "grow flex items-center gap-2 pli-2 order-2",
    onClick: () => addedIdentity && joinSend({
      type: "selectIdentity",
      identity: addedIdentity
    }),
    "data-autofocus": "confirmingAddedIdentity"
  }, /* @__PURE__ */ React23.createElement(CaretLeft, {
    weight: "bold",
    className: mx16(getSize9(2), "invisible")
  }), /* @__PURE__ */ React23.createElement("span", {
    className: "grow"
  }, t("continue label")), /* @__PURE__ */ React23.createElement(CaretRight2, {
    weight: "bold",
    className: getSize9(4)
  })), /* @__PURE__ */ React23.createElement(Button6, {
    disabled,
    onClick: () => joinSend({
      type: "deselectAuthMethod"
    }),
    className: "flex items-center gap-2 pis-2 pie-4"
  }, /* @__PURE__ */ React23.createElement(CaretLeft, {
    weight: "bold",
    className: getSize9(4)
  }), /* @__PURE__ */ React23.createElement("span", null, t("deselect identity label")))));
};

// packages/apps/patterns/react-ui/src/panels/JoinPanel/view-states/IdentityInput.tsx
import { CaretLeft as CaretLeft2, CaretRight as CaretRight3 } from "@phosphor-icons/react";
import React24, { useState as useState3 } from "react";
import { useClient as useClient4 } from "@dxos/react-client";
import { Button as Button7, getSize as getSize10, Input, mx as mx17, useTranslation as useTranslation12 } from "@dxos/react-components";
function _extends18() {
  _extends18 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends18.apply(this, arguments);
}
var IdentityInput = ({ method, ...viewStateProps }) => {
  const disabled = !viewStateProps.active;
  const { joinSend } = viewStateProps;
  const { t } = useTranslation12("os");
  const [inputValue, setInputValue] = useState3("");
  const client = useClient4();
  const [validationMessage, setValidationMessage] = useState3("");
  const isRecover = method === "recover identity";
  const handleNext = () => {
    void client.halo.createIdentity({
      [isRecover ? "seedphrase" : "displayName"]: inputValue
    }).then((identity) => {
      joinSend({
        type: "selectIdentity",
        identity
      });
    }, (_error) => {
      setValidationMessage(t(isRecover ? "failed to recover identity message" : "failed to create identity message"));
    });
  };
  return /* @__PURE__ */ React24.createElement(ViewState, _extends18({}, viewStateProps), /* @__PURE__ */ React24.createElement(Input, _extends18({
    disabled,
    label: /* @__PURE__ */ React24.createElement(ViewStateHeading, null, t(isRecover ? "recover identity input label" : "new identity input label")),
    onChange: ({ target: { value } }) => setInputValue(value),
    slots: {
      root: {
        className: "m-0"
      },
      input: {
        "data-autofocus": isRecover ? "recoveringIdentity" : "creatingIdentity",
        onKeyUp: ({ key }) => key === "Enter" && handleNext()
      }
    }
  }, validationMessage.length && {
    validationValence: "error",
    validationMessage
  }, {
    "data-testid": "identity-input"
  })), /* @__PURE__ */ React24.createElement("div", {
    role: "none",
    className: "grow"
  }), /* @__PURE__ */ React24.createElement("div", {
    className: "flex gap-2"
  }, /* @__PURE__ */ React24.createElement(Button7, {
    disabled,
    className: "grow flex items-center gap-2 pli-2 order-2",
    onClick: handleNext,
    "data-testid": `${method === "recover identity" ? "recover" : "create"}-identity-input-continue`
  }, /* @__PURE__ */ React24.createElement(CaretLeft2, {
    weight: "bold",
    className: mx17(getSize10(2), "invisible")
  }), /* @__PURE__ */ React24.createElement("span", {
    className: "grow"
  }, t("continue label")), /* @__PURE__ */ React24.createElement(CaretRight3, {
    weight: "bold",
    className: getSize10(4)
  })), /* @__PURE__ */ React24.createElement(Button7, {
    disabled,
    onClick: () => joinSend({
      type: "deselectAuthMethod"
    }),
    className: "flex items-center gap-2 pis-2 pie-4",
    "data-testid": `${method === "recover identity" ? "recover" : "create"}-identity-input-back`
  }, /* @__PURE__ */ React24.createElement(CaretLeft2, {
    weight: "bold",
    className: getSize10(4)
  }), /* @__PURE__ */ React24.createElement("span", null, t("back label")))));
};

// packages/apps/patterns/react-ui/src/panels/JoinPanel/view-states/InvitationAccepted.tsx
import { CaretLeft as CaretLeft3, Check as Check3 } from "@phosphor-icons/react";
import React25, { cloneElement as cloneElement4 } from "react";
import { useInvitationStatus as useInvitationStatus3 } from "@dxos/react-client";
import { Button as Button8, getSize as getSize11, mx as mx18, useTranslation as useTranslation13 } from "@dxos/react-components";
function _extends19() {
  _extends19 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends19.apply(this, arguments);
}
var PureInvitationAcceptedContent = ({ onDone, result, Kind, doneActionParent, active }) => {
  const disabled = !active;
  const { t } = useTranslation13("os");
  const doneButton = /* @__PURE__ */ React25.createElement(Button8, {
    onClick: () => onDone == null ? void 0 : onDone(result),
    disabled,
    className: "flex items-center gap-2 pli-2",
    "data-autofocus": `success${Kind}Invitation finishingJoining${Kind}`,
    "data-testid": `${Kind.toLowerCase()}-invitation-accepted-done`
  }, /* @__PURE__ */ React25.createElement(CaretLeft3, {
    weight: "bold",
    className: mx18(getSize11(2), "invisible")
  }), /* @__PURE__ */ React25.createElement("span", {
    className: "grow"
  }, t("done label")), /* @__PURE__ */ React25.createElement(Check3, {
    className: getSize11(4)
  }));
  return /* @__PURE__ */ React25.createElement(React25.Fragment, null, /* @__PURE__ */ React25.createElement("p", {
    className: "text-center text-sm font-system-normal"
  }, t("welcome message")), /* @__PURE__ */ React25.createElement("div", {
    role: "none",
    className: "grow"
  }), doneActionParent ? /* @__PURE__ */ cloneElement4(doneActionParent, {}, doneButton) : doneButton);
};
var InvitationAcceptedContent = (props) => {
  const { result } = useInvitationStatus3(props.activeInvitation);
  return /* @__PURE__ */ React25.createElement(PureInvitationAcceptedContent, _extends19({}, props, {
    result
  }));
};
var InvitationAccepted = (props) => {
  var _a;
  const { Kind, doneActionParent: _doneActionParent, onDone: _onDone, ...viewStateProps } = props;
  const activeInvitation = (_a = viewStateProps.joinState) == null ? void 0 : _a.context[Kind.toLowerCase()].invitationObservable;
  return /* @__PURE__ */ React25.createElement(ViewState, _extends19({}, viewStateProps), !activeInvitation ? /* @__PURE__ */ React25.createElement(PureInvitationAcceptedContent, _extends19({}, props, {
    result: null
  })) : /* @__PURE__ */ React25.createElement(InvitationAcceptedContent, _extends19({}, props, {
    activeInvitation
  })));
};

// packages/apps/patterns/react-ui/src/panels/JoinPanel/view-states/InvitationInput.tsx
import { CaretLeft as CaretLeft4, CaretRight as CaretRight4 } from "@phosphor-icons/react";
import React26, { useEffect, useState as useState4 } from "react";
import { Button as Button9, getSize as getSize12, Input as Input2, mx as mx19, useTranslation as useTranslation14 } from "@dxos/react-components";
function _extends20() {
  _extends20 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends20.apply(this, arguments);
}
var InvitationInput = ({ Kind, ...viewStateProps }) => {
  const disabled = !viewStateProps.active;
  const { joinSend, joinState } = viewStateProps;
  const { t } = useTranslation14("os");
  const contextUnredeemedCode = joinState == null ? void 0 : joinState.context[Kind.toLowerCase()].unredeemedCode;
  const [inputValue, setInputValue] = useState4(contextUnredeemedCode != null ? contextUnredeemedCode : "");
  useEffect(() => {
    contextUnredeemedCode && setInputValue(contextUnredeemedCode != null ? contextUnredeemedCode : "");
  }, [
    contextUnredeemedCode
  ]);
  const handleNext = () => joinSend({
    type: `set${Kind}InvitationCode`,
    code: inputValue
  });
  return /* @__PURE__ */ React26.createElement(ViewState, _extends20({}, viewStateProps), /* @__PURE__ */ React26.createElement(Input2, {
    disabled,
    label: /* @__PURE__ */ React26.createElement(ViewStateHeading, null, t("invitation input label")),
    value: inputValue,
    onChange: ({ target: { value } }) => setInputValue(value),
    slots: {
      root: {
        className: "m-0"
      },
      input: {
        "data-autofocus": `inputting${Kind}InvitationCode`,
        "data-testid": `${Kind.toLowerCase()}-invitation-input`,
        onKeyUp: ({ key }) => key === "Enter" && handleNext()
      }
    }
  }), /* @__PURE__ */ React26.createElement("div", {
    role: "none",
    className: "grow"
  }), /* @__PURE__ */ React26.createElement("div", {
    className: "flex gap-2"
  }, /* @__PURE__ */ React26.createElement(Button9, {
    disabled,
    className: "grow flex items-center gap-2 pli-2 order-2",
    onClick: handleNext,
    "data-testid": `${Kind.toLowerCase()}-invitation-input-continue`
  }, /* @__PURE__ */ React26.createElement(CaretLeft4, {
    weight: "bold",
    className: mx19(getSize12(2), "invisible")
  }), /* @__PURE__ */ React26.createElement("span", {
    className: "grow"
  }, t("continue label")), /* @__PURE__ */ React26.createElement(CaretRight4, {
    weight: "bold",
    className: getSize12(4)
  })), /* @__PURE__ */ React26.createElement(Button9, {
    disabled: disabled || Kind === "Space",
    onClick: () => joinSend({
      type: "deselectAuthMethod"
    }),
    className: "flex items-center gap-2 pis-2 pie-4",
    "data-testid": `${Kind.toLowerCase()}-invitation-input-back`
  }, /* @__PURE__ */ React26.createElement(CaretLeft4, {
    weight: "bold",
    className: getSize12(4)
  }), /* @__PURE__ */ React26.createElement("span", null, t("back label")))));
};

// packages/apps/patterns/react-ui/src/panels/JoinPanel/view-states/InvitationRescuer.tsx
import { ArrowsClockwise, CaretLeft as CaretLeft5, CaretRight as CaretRight5 } from "@phosphor-icons/react";
import React27 from "react";
import { Invitation as Invitation6 } from "@dxos/client";
import { Button as Button10, defaultDescription as defaultDescription3, getSize as getSize13, mx as mx20, useTranslation as useTranslation15 } from "@dxos/react-components";
function _extends21() {
  _extends21 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends21.apply(this, arguments);
}
var InvitationActions = ({ invitationState, disabled, joinSend, joinState, Kind }) => {
  const { t } = useTranslation15("os");
  const invitationType = Kind.toLowerCase();
  switch (invitationState) {
    case Invitation6.State.CONNECTING:
      return /* @__PURE__ */ React27.createElement(React27.Fragment, null, /* @__PURE__ */ React27.createElement(ViewStateHeading, {
        className: defaultDescription3
      }, t("connecting status label")), /* @__PURE__ */ React27.createElement("div", {
        role: "none",
        className: "grow"
      }), /* @__PURE__ */ React27.createElement("div", {
        className: "flex gap-2"
      }, /* @__PURE__ */ React27.createElement(Button10, {
        disabled: true,
        className: "grow flex items-center gap-2 pli-2 order-2",
        "data-testid": "next"
      }, /* @__PURE__ */ React27.createElement(CaretLeft5, {
        weight: "bold",
        className: mx20(getSize13(2), "invisible")
      }), /* @__PURE__ */ React27.createElement("span", {
        className: "grow"
      }, t("next label")), /* @__PURE__ */ React27.createElement(CaretRight5, {
        weight: "bold",
        className: getSize13(4)
      })), /* @__PURE__ */ React27.createElement(Button10, {
        disabled,
        className: "flex items-center gap-2 pis-2 pie-4",
        onClick: () => {
          var _a;
          return (_a = joinState == null ? void 0 : joinState.context[invitationType].invitationObservable) == null ? void 0 : _a.cancel();
        },
        "data-testid": "invitation-rescuer-cancel"
      }, /* @__PURE__ */ React27.createElement(CaretLeft5, {
        weight: "bold",
        className: getSize13(4)
      }), /* @__PURE__ */ React27.createElement("span", null, t("cancel label")))));
    case Invitation6.State.TIMEOUT:
    case Invitation6.State.CANCELLED:
    case Invitation6.State.ERROR:
    default:
      return /* @__PURE__ */ React27.createElement(React27.Fragment, null, /* @__PURE__ */ React27.createElement(ViewStateHeading, {
        className: defaultDescription3
      }, t(invitationState === Invitation6.State.TIMEOUT ? "timeout status label" : invitationState === Invitation6.State.CANCELLED ? "cancelled status label" : "error status label")), /* @__PURE__ */ React27.createElement("div", {
        role: "none",
        className: "grow"
      }), /* @__PURE__ */ React27.createElement(Button10, {
        disabled,
        className: "flex items-center gap-2 pli-2",
        onClick: () => joinSend({
          type: `reset${Kind}Invitation`
        }),
        "data-testid": "invitation-rescuer-reset"
      }, /* @__PURE__ */ React27.createElement(CaretLeft5, {
        weight: "bold",
        className: mx20(getSize13(5), "invisible")
      }), /* @__PURE__ */ React27.createElement("span", {
        className: "grow"
      }, t("reset label")), /* @__PURE__ */ React27.createElement(ArrowsClockwise, {
        className: getSize13(4)
      })));
  }
};
var InvitationRescuer = ({ Kind, ...viewStateProps }) => {
  var _a;
  const disabled = !viewStateProps.active;
  const { joinSend, joinState } = viewStateProps;
  const invitationState = (_a = joinState == null ? void 0 : joinState.context[Kind.toLowerCase()].invitation) == null ? void 0 : _a.state;
  const { t } = useTranslation15("os");
  return /* @__PURE__ */ React27.createElement(ViewState, _extends21({}, viewStateProps), typeof invitationState === "undefined" ? /* @__PURE__ */ React27.createElement(React27.Fragment, null, /* @__PURE__ */ React27.createElement("div", {
    role: "none",
    className: "grow"
  }), /* @__PURE__ */ React27.createElement(Button10, {
    disabled,
    className: "flex items-center gap-2 pli-2",
    "data-autofocus": `inputting${Kind}InvitationCode`,
    "data-testid": "invitation-rescuer-blank-reset",
    onClick: () => joinSend({
      type: `reset${Kind}Invitation`
    })
  }, /* @__PURE__ */ React27.createElement(CaretLeft5, {
    weight: "bold",
    className: mx20(getSize13(5), "invisible")
  }), /* @__PURE__ */ React27.createElement("span", {
    className: "grow"
  }, t("reset label")), /* @__PURE__ */ React27.createElement(ArrowsClockwise, {
    className: getSize13(5)
  }))) : /* @__PURE__ */ React27.createElement(InvitationActions, _extends21({}, {
    invitationState,
    disabled,
    joinSend,
    joinState,
    Kind
  })));
};

// packages/apps/patterns/react-ui/src/panels/JoinPanel/view-states/InvitationAuthenticator.tsx
import { CaretLeft as CaretLeft6, CaretRight as CaretRight6 } from "@phosphor-icons/react";
import React28, { useCallback as useCallback6, useState as useState5 } from "react";
import { useInvitationStatus as useInvitationStatus4 } from "@dxos/react-client";
import { Button as Button11, getSize as getSize14, Input as Input3, mx as mx21, useTranslation as useTranslation16 } from "@dxos/react-components";
function _extends22() {
  _extends22 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends22.apply(this, arguments);
}
var pinLength = 6;
var PureInvitationAuthenticatorContent = ({ disabled, failed, joinSend, joinState, Kind, onChange, onAuthenticate }) => {
  const { t } = useTranslation16("os");
  const invitationType = Kind.toLowerCase();
  return /* @__PURE__ */ React28.createElement(React28.Fragment, null, /* @__PURE__ */ React28.createElement(Input3, _extends22({
    label: /* @__PURE__ */ React28.createElement(ViewStateHeading, null, t("auth code input label")),
    size: "pin",
    length: pinLength,
    onChange,
    disabled,
    slots: {
      root: {
        className: "m-0"
      },
      description: {
        className: "text-center"
      },
      input: {
        disabled,
        inputMode: "numeric",
        autoComplete: "off",
        pattern: "\\d*",
        "data-autofocus": `connecting${Kind}Invitation inputting${Kind}VerificationCode authenticationFailing${Kind}VerificationCode authenticating${Kind}VerificationCode`,
        "data-prevent-ios-autofocus": true,
        "data-testid": `${invitationType}-auth-code-input`,
        "data-1p-ignore": true
      }
    }
  }, failed && {
    validationValence: "error",
    validationMessage: t("failed to authenticate message")
  })), /* @__PURE__ */ React28.createElement("div", {
    role: "none",
    className: "grow"
  }), /* @__PURE__ */ React28.createElement("div", {
    className: "flex gap-2"
  }, /* @__PURE__ */ React28.createElement(Button11, {
    disabled,
    className: "grow flex items-center gap-2 pli-2 order-2",
    onClick: onAuthenticate,
    "data-autofocus-pinlength": invitationType,
    "data-testid": `${invitationType}-invitation-authenticator-next`
  }, /* @__PURE__ */ React28.createElement(CaretLeft6, {
    weight: "bold",
    className: mx21(getSize14(2), "invisible")
  }), /* @__PURE__ */ React28.createElement("span", {
    className: "grow"
  }, t("next label")), /* @__PURE__ */ React28.createElement(CaretRight6, {
    weight: "bold",
    className: getSize14(4)
  })), /* @__PURE__ */ React28.createElement(Button11, {
    disabled,
    className: "flex items-center gap-2 pis-2 pie-4",
    onClick: () => {
      var _a;
      return (_a = joinState == null ? void 0 : joinState.context[invitationType].invitationObservable) == null ? void 0 : _a.cancel();
    },
    "data-testid": `${invitationType}-invitation-authenticator-cancel`
  }, /* @__PURE__ */ React28.createElement(CaretLeft6, {
    weight: "bold",
    className: getSize14(4)
  }), /* @__PURE__ */ React28.createElement("span", null, t("cancel label")))));
};
var InvitationAuthenticatorContent = ({ joinSend, joinState, disabled, invitation, Kind, failed }) => {
  const invitationType = Kind.toLowerCase();
  const [pinValue, setPinValue] = useState5("");
  const { authenticate } = useInvitationStatus4(invitation);
  const onAuthenticate = useCallback6(() => {
    joinSend({
      type: `authenticate${Kind}VerificationCode`
    });
    void authenticate(pinValue);
  }, [
    joinSend,
    authenticate,
    pinValue
  ]);
  const onChange = useCallback6(({ target: { value } }) => {
    var _a;
    setPinValue(value);
    if (value.length === pinLength) {
      (_a = document.querySelector(`[data-autofocus-pinlength="${invitationType}"]`)) == null ? void 0 : _a.focus();
    }
  }, [
    authenticate,
    pinValue
  ]);
  return /* @__PURE__ */ React28.createElement(PureInvitationAuthenticatorContent, _extends22({}, {
    disabled,
    failed,
    joinSend,
    joinState,
    Kind,
    onChange,
    onAuthenticate
  }));
};
var InvitationAuthenticator = ({ failed, Kind, ...viewStateProps }) => {
  const { joinSend, joinState } = viewStateProps;
  const disabled = !viewStateProps.active || [
    "connecting",
    "authenticating"
  ].some((str) => joinState == null ? void 0 : joinState.configuration[0].id.includes(str));
  const activeInvitation = joinState == null ? void 0 : joinState.context[Kind.toLowerCase()].invitationObservable;
  return /* @__PURE__ */ React28.createElement(ViewState, _extends22({}, viewStateProps), !activeInvitation ? /* @__PURE__ */ React28.createElement(PureInvitationAuthenticatorContent, _extends22({}, {
    disabled,
    failed,
    joinSend,
    joinState,
    Kind,
    onChange: () => {
    },
    onAuthenticate: () => {
    }
  })) : /* @__PURE__ */ React28.createElement(InvitationAuthenticatorContent, _extends22({}, {
    disabled,
    failed,
    invitation: activeInvitation,
    joinSend,
    joinState,
    Kind
  })));
};

// packages/apps/patterns/react-ui/src/panels/JoinPanel/JoinPanel.tsx
function _extends23() {
  _extends23 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends23.apply(this, arguments);
}
var JoinPanel = ({ mode = "default", initialInvitationCode, exitActionParent, onExit, doneActionParent, onDone, preventExit }) => {
  const client = useClient5();
  const identity = useIdentity2();
  const titleId = useId4("joinPanel__title");
  const { hasIosKeyboard } = useThemeContext2();
  const [joinState, joinSend, joinService] = useJoinMachine(client, {
    context: {
      mode,
      identity,
      ...initialInvitationCode && {
        [mode === "halo-only" ? "halo" : "space"]: {
          unredeemedCode: initialInvitationCode
        }
      }
    }
  });
  useEffect2(() => {
    const subscription = joinService.subscribe((state) => {
      log2("[state]", state, {
        file: "JoinPanel.tsx",
        line: 49,
        scope: void 0,
        callSite: (f, a) => f(...a)
      });
    });
    return subscription.unsubscribe;
  }, [
    joinService
  ]);
  useEffect2(() => {
    const stateStack = joinState.configuration[0].id.split(".");
    const innermostState = stateStack[stateStack.length - 1];
    const autoFocusValue = innermostState === "finishingJoining" ? "successSpaceInvitation" : innermostState;
    const $nextAutofocus = document.querySelector(`[data-autofocus~="${autoFocusValue}"]`);
    if ($nextAutofocus && !(hasIosKeyboard && $nextAutofocus.hasAttribute("data-prevent-ios-autofocus"))) {
      $nextAutofocus.focus();
    }
  }, [
    joinState.value,
    hasIosKeyboard
  ]);
  return /* @__PURE__ */ React29.createElement(DensityProvider4, {
    density: "fine"
  }, /* @__PURE__ */ React29.createElement(JoinHeading, _extends23({}, {
    mode,
    titleId,
    joinState,
    onExit,
    exitActionParent,
    preventExit
  })), /* @__PURE__ */ React29.createElement("div", {
    role: "none",
    className: "is-full overflow-hidden"
  }, /* @__PURE__ */ React29.createElement("div", {
    role: "none",
    className: "flex is-[1200%]",
    "aria-live": "polite"
  }, /* @__PURE__ */ React29.createElement(AdditionMethodSelector, _extends23({}, {
    joinState,
    joinSend,
    active: joinState.matches({
      choosingIdentity: "choosingAuthMethod"
    })
  })), /* @__PURE__ */ React29.createElement(IdentityInput, _extends23({}, {
    joinState,
    joinSend,
    active: joinState.matches({
      choosingIdentity: "creatingIdentity"
    }),
    method: "create identity"
  })), /* @__PURE__ */ React29.createElement(IdentityInput, _extends23({}, {
    joinState,
    joinSend,
    active: joinState.matches({
      choosingIdentity: "recoveringIdentity"
    }),
    method: "recover identity"
  })), /* @__PURE__ */ React29.createElement(InvitationInput, _extends23({}, {
    joinState,
    joinSend,
    active: joinState.matches({
      choosingIdentity: {
        acceptingHaloInvitation: "inputtingHaloInvitationCode"
      }
    }),
    Kind: "Halo"
  })), /* @__PURE__ */ React29.createElement(InvitationRescuer, _extends23({}, {
    joinState,
    joinSend,
    active: [
      {
        choosingIdentity: {
          acceptingHaloInvitation: {
            acceptingRedeemedHaloInvitation: "connectingHaloInvitation"
          }
        }
      },
      {
        choosingIdentity: {
          acceptingHaloInvitation: {
            acceptingRedeemedHaloInvitation: "failingHaloInvitation"
          }
        }
      }
    ].some(joinState.matches),
    Kind: "Halo"
  })), /* @__PURE__ */ React29.createElement(InvitationAuthenticator, _extends23({}, {
    joinState,
    joinSend,
    active: [
      {
        choosingIdentity: {
          acceptingHaloInvitation: {
            acceptingRedeemedHaloInvitation: "inputtingHaloVerificationCode"
          }
        }
      },
      {
        choosingIdentity: {
          acceptingHaloInvitation: {
            acceptingRedeemedHaloInvitation: "authenticatingHaloVerificationCode"
          }
        }
      },
      {
        choosingIdentity: {
          acceptingHaloInvitation: {
            acceptingRedeemedHaloInvitation: "authenticationFailingHaloVerificationCode"
          }
        }
      }
    ].some(joinState.matches),
    Kind: "Halo",
    ...joinState.matches({
      acceptingHaloInvitation: {
        acceptingRedeemedHaloInvitation: "authenticationFailingHaloVerificationCode"
      }
    }) && {
      failed: true
    }
  })), /* @__PURE__ */ React29.createElement(InvitationAccepted, _extends23({}, {
    joinState,
    joinSend,
    active: [
      {
        choosingIdentity: {
          acceptingHaloInvitation: {
            acceptingRedeemedHaloInvitation: "successHaloInvitation"
          }
        }
      },
      "finishingJoiningHalo"
    ].some(joinState.matches),
    Kind: "Halo",
    doneActionParent,
    onDone
  })), /* @__PURE__ */ React29.createElement(IdentityAdded, _extends23({}, {
    joinState,
    joinSend,
    mode,
    active: joinState.matches({
      choosingIdentity: "confirmingAddedIdentity"
    }),
    doneActionParent,
    onDone
  })), /* @__PURE__ */ React29.createElement(InvitationInput, _extends23({}, {
    joinState,
    joinSend,
    active: joinState.matches({
      acceptingSpaceInvitation: "inputtingSpaceInvitationCode"
    }),
    Kind: "Space"
  })), /* @__PURE__ */ React29.createElement(InvitationRescuer, _extends23({}, {
    joinState,
    joinSend,
    active: [
      {
        acceptingSpaceInvitation: {
          acceptingRedeemedSpaceInvitation: "connectingSpaceInvitation"
        }
      },
      {
        acceptingSpaceInvitation: {
          acceptingRedeemedSpaceInvitation: "failingSpaceInvitation"
        }
      }
    ].some(joinState.matches),
    Kind: "Space"
  })), /* @__PURE__ */ React29.createElement(InvitationAuthenticator, _extends23({}, {
    joinState,
    joinSend,
    active: [
      {
        acceptingSpaceInvitation: {
          acceptingRedeemedSpaceInvitation: "inputtingSpaceVerificationCode"
        }
      },
      {
        acceptingSpaceInvitation: {
          acceptingRedeemedSpaceInvitation: "authenticatingSpaceVerificationCode"
        }
      },
      {
        acceptingSpaceInvitation: {
          acceptingRedeemedSpaceInvitation: "authenticationFailingSpaceVerificationCode"
        }
      }
    ].some(joinState.matches),
    Kind: "Space",
    ...joinState.matches({
      acceptingSpaceInvitation: {
        acceptingRedeemedSpaceInvitation: "authenticationFailingSpaceVerificationCode"
      }
    }) && {
      failed: true
    }
  })), /* @__PURE__ */ React29.createElement(InvitationAccepted, _extends23({}, {
    joinState,
    joinSend,
    active: joinState.matches("finishingJoiningSpace"),
    Kind: "Space",
    doneActionParent,
    onDone
  })))));
};

// packages/apps/patterns/react-ui/src/panels/SpacePanel/SpacePanel.tsx
import { UserPlus as UserPlus2 } from "@phosphor-icons/react";
import React30, { useCallback as useCallback7, useReducer as useReducer2 } from "react";
import { InvitationEncoder as InvitationEncoder2 } from "@dxos/client";
import { useSpaceInvitations as useSpaceInvitations2, observer } from "@dxos/react-client";
import { Button as Button12, DensityProvider as DensityProvider5, getSize as getSize15, mx as mx22, useTranslation as useTranslation17 } from "@dxos/react-components";
function _extends24() {
  _extends24 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends24.apply(this, arguments);
}
var CurrentSpaceView = observer(({ space, createInvitationUrl, titleId }) => {
  const { t } = useTranslation17("os");
  const invitations = useSpaceInvitations2(space == null ? void 0 : space.key);
  const name = space == null ? void 0 : space.properties.name;
  console.log("[space panel]", "development");
  if (!space) {
    return null;
  }
  const onInvitationEvent = useCallback7((invitation) => {
    const invitationCode = InvitationEncoder2.encode(invitation);
    console.log(JSON.stringify({
      invitationCode
    }));
    if (invitation.authCode) {
      console.log(JSON.stringify({
        authCode: invitation.authCode
      }));
    }
  }, []);
  return /* @__PURE__ */ React30.createElement("div", {
    role: "none",
    className: "flex flex-col"
  }, /* @__PURE__ */ React30.createElement("div", {
    role: "none",
    className: mx22(subduedSurface, "rounded-bs-md flex items-center p-2 gap-2")
  }, /* @__PURE__ */ React30.createElement("h2", {
    id: titleId,
    className: mx22("grow font-system-medium", !name && "font-mono")
  }, name != null ? name : space.key.truncate())), /* @__PURE__ */ React30.createElement("div", {
    role: "region",
    className: mx22(defaultSurface, "rounded-be-md p-2")
  }, /* @__PURE__ */ React30.createElement(InvitationList, {
    invitations,
    onClickRemove: (invitation) => invitation.get() && (space == null ? void 0 : space.removeInvitation(invitation.get().invitationId)),
    createInvitationUrl
  }), /* @__PURE__ */ React30.createElement(Button12, {
    className: "is-full flex gap-2 mbs-2",
    onClick: () => {
      const invitation = space == null ? void 0 : space.createInvitation();
      if (true) {
        invitation.subscribe(onInvitationEvent);
      }
    },
    "data-testid": "spaces-panel.create-invitation"
  }, /* @__PURE__ */ React30.createElement("span", null, t("create space invitation label")), /* @__PURE__ */ React30.createElement(UserPlus2, {
    className: getSize15(4),
    weight: "bold"
  })), /* @__PURE__ */ React30.createElement(PanelSeparator, null), /* @__PURE__ */ React30.createElement(SpaceMemberListContainer, {
    spaceKey: space.key,
    includeSelf: true
  })));
});
var SpacePanel = (props) => {
  const reducer = (state, action) => {
    const nextState = {
      ...state
    };
    switch (action.type) {
      case null:
    }
    return nextState;
  };
  const [panelState] = useReducer2(reducer, {
    activeView: "current space"
  });
  return /* @__PURE__ */ React30.createElement(DensityProvider5, {
    density: "fine"
  }, panelState.activeView === "current space" ? /* @__PURE__ */ React30.createElement(CurrentSpaceView, _extends24({}, props)) : null);
};

// packages/apps/patterns/react-ui/src/composites/IdentityPopover/IdentityPopover.tsx
function _extends25() {
  _extends25 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends25.apply(this, arguments);
}
var IdentityPopover = ({ identity, openTrigger, slots, triggerIsInToolbar = true, onClickManageProfile, ...popoverProps }) => {
  var _a, _b, _c;
  return /* @__PURE__ */ React31.createElement(PanelPopover, _extends25({}, popoverProps, {
    openTrigger: openTrigger != null ? openTrigger : /* @__PURE__ */ React31.createElement(Avatar5, {
      size: 10,
      variant: "circle",
      fallbackValue: identity.identityKey.toHex(),
      label: (_b = (_a = identity.profile) == null ? void 0 : _a.displayName) != null ? _b : ""
    }),
    slots: {
      ...slots,
      trigger: {
        ...slots == null ? void 0 : slots.trigger,
        className: mx23("flex justify-self-end pointer-events-auto bg-white dark:bg-neutral-700 p-0.5 button-elevation rounded-full", (_c = slots == null ? void 0 : slots.trigger) == null ? void 0 : _c.className)
      }
    },
    triggerIsInToolbar
  }), /* @__PURE__ */ React31.createElement(IdentityPanel, _extends25({}, {
    identity,
    onClickManageProfile
  })));
};

// packages/apps/patterns/react-ui/src/composites/JoinDialog/JoinDialog.tsx
import { Action, Cancel } from "@radix-ui/react-alert-dialog";
import React32 from "react";
import { ThemeContext as ThemeContext2, useId as useId5, useThemeContext as useThemeContext3 } from "@dxos/react-components";
function _extends26() {
  _extends26 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends26.apply(this, arguments);
}
var JoinDialog = ({ slots, ...joinPanelProps }) => {
  const titleId = useId5("joinDialog__title");
  const themeContextValue = useThemeContext3();
  return /* @__PURE__ */ React32.createElement(PanelAlertDialog, _extends26({}, {
    slots,
    titleId
  }), /* @__PURE__ */ React32.createElement(ThemeContext2.Provider, {
    value: {
      ...themeContextValue,
      themeVariant: "os"
    }
  }, /* @__PURE__ */ React32.createElement(JoinPanel, _extends26({}, {
    ...joinPanelProps,
    titleId,
    exitActionParent: /* @__PURE__ */ React32.createElement(Cancel, {
      asChild: true
    }),
    doneActionParent: /* @__PURE__ */ React32.createElement(Action, {
      asChild: true
    })
  }))));
};

// packages/apps/patterns/react-ui/src/composites/Shell/Shell.tsx
import React35, { useEffect as useEffect3, useState as useState6 } from "react";
import { log as log3 } from "@dxos/log";
import { ShellDisplay, ShellLayout } from "@dxos/protocols/proto/dxos/iframe";
import { useClient as useClient6, useSpace as useSpace3, useSpaces } from "@dxos/react-client";

// packages/apps/patterns/react-ui/src/composites/DevicesDialog/DevicesDialog.tsx
import { Close } from "@radix-ui/react-dialog";
import React33 from "react";
import { ThemeContext as ThemeContext3, useId as useId6, useThemeContext as useThemeContext4 } from "@dxos/react-components";
function _extends27() {
  _extends27 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends27.apply(this, arguments);
}
var DevicesDialog = ({ slots, ...devicesDialogProps }) => {
  const titleId = useId6("spaceDialog__title");
  const themeContextValue = useThemeContext4();
  return /* @__PURE__ */ React33.createElement(PanelDialog, _extends27({}, {
    slots: {
      ...slots,
      root: {
        onOpenChange: (open) => {
          var _a;
          return open || ((_a = devicesDialogProps.onDone) == null ? void 0 : _a.call(devicesDialogProps));
        },
        ...slots == null ? void 0 : slots.root
      }
    },
    titleId
  }), /* @__PURE__ */ React33.createElement(ThemeContext3.Provider, {
    value: {
      ...themeContextValue,
      themeVariant: "os"
    }
  }, /* @__PURE__ */ React33.createElement(DevicesPanel, _extends27({}, {
    ...devicesDialogProps,
    titleId,
    doneActionParent: /* @__PURE__ */ React33.createElement(Close, {
      asChild: true
    })
  }))));
};

// packages/apps/patterns/react-ui/src/composites/SpaceDialog/SpaceDialog.tsx
import { Close as Close2 } from "@radix-ui/react-dialog";
import React34 from "react";
import { ThemeContext as ThemeContext4, useId as useId7, useThemeContext as useThemeContext5 } from "@dxos/react-components";
function _extends28() {
  _extends28 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends28.apply(this, arguments);
}
var SpaceDialog = ({ slots, ...spacePanelProps }) => {
  const titleId = useId7("spaceDialog__title");
  const themeContextValue = useThemeContext5();
  return /* @__PURE__ */ React34.createElement(PanelDialog, _extends28({}, {
    slots: {
      ...slots,
      root: {
        onOpenChange: (open) => {
          var _a;
          return open || ((_a = spacePanelProps.onDone) == null ? void 0 : _a.call(spacePanelProps));
        },
        ...slots == null ? void 0 : slots.root
      }
    },
    titleId
  }), /* @__PURE__ */ React34.createElement(ThemeContext4.Provider, {
    value: {
      ...themeContextValue,
      themeVariant: "os"
    }
  }, /* @__PURE__ */ React34.createElement(SpacePanel, _extends28({}, {
    ...spacePanelProps,
    titleId,
    doneActionParent: /* @__PURE__ */ React34.createElement(Close2, {
      asChild: true
    })
  }))));
};

// packages/apps/patterns/react-ui/src/composites/Shell/Shell.tsx
var Shell = ({ runtime, origin }) => {
  const [{ layout, invitationCode, spaceKey }, setLayout] = useState6({
    layout: runtime.layout,
    invitationCode: runtime.invitationCode,
    spaceKey: runtime.spaceKey
  });
  const client = useClient6();
  const spaces = useSpaces();
  const space = useSpace3(spaceKey);
  useEffect3(() => {
    return runtime.layoutUpdate.on((request) => setLayout(request));
  }, [
    runtime
  ]);
  useEffect3(() => {
    if (layout === ShellLayout.SPACE_INVITATIONS && !space) {
      log3.warn("No space found for shell space invitations.", {}, {
        file: "Shell.tsx",
        line: 33,
        scope: void 0,
        callSite: (f, a) => f(...a)
      });
      const timeout = setTimeout(async () => {
        await runtime.setAppContext({
          display: ShellDisplay.NONE
        });
        runtime.setLayout(ShellLayout.DEFAULT);
      });
      return () => clearTimeout(timeout);
    }
  }, [
    runtime,
    layout,
    space
  ]);
  switch (layout) {
    case ShellLayout.INITIALIZE_IDENTITY:
      return /* @__PURE__ */ React35.createElement(JoinDialog, {
        mode: "halo-only",
        initialInvitationCode: invitationCode,
        onDone: () => {
          void runtime.setAppContext({
            display: ShellDisplay.NONE
          });
          runtime.setLayout(ShellLayout.DEFAULT);
          spaces.length > 0 || client.createSpace();
        }
      });
    case ShellLayout.DEVICE_INVITATIONS:
      return /* @__PURE__ */ React35.createElement(DevicesDialog, {
        createInvitationUrl: (invitationCode2) => `${origin}?haloInvitationCode=${invitationCode2}`,
        onDone: async () => {
          await runtime.setAppContext({
            display: ShellDisplay.NONE
          });
          runtime.setLayout(ShellLayout.DEFAULT);
        }
      });
    case ShellLayout.SPACE_INVITATIONS:
      return space ? /* @__PURE__ */ React35.createElement(SpaceDialog, {
        space,
        createInvitationUrl: (invitationCode2) => `${origin}?spaceInvitationCode=${invitationCode2}`,
        onDone: async () => {
          await runtime.setAppContext({
            display: ShellDisplay.NONE
          });
          runtime.setLayout(ShellLayout.DEFAULT);
        }
      }) : null;
    case ShellLayout.JOIN_SPACE:
      return /* @__PURE__ */ React35.createElement(JoinDialog, {
        initialInvitationCode: invitationCode,
        onDone: async (result) => {
          var _a;
          await runtime.setAppContext({
            display: ShellDisplay.NONE,
            spaceKey: (_a = result == null ? void 0 : result.spaceKey) != null ? _a : void 0
          });
          runtime.setLayout(ShellLayout.DEFAULT);
        },
        onExit: async () => {
          await runtime.setAppContext({
            display: ShellDisplay.NONE
          });
          runtime.setLayout(ShellLayout.DEFAULT);
        }
      });
    default:
      return null;
  }
};

// packages/apps/patterns/react-ui/src/composites/Shell/ShellContext.tsx
import React36, { createContext as createContext3, useCallback as useCallback8, useContext as useContext3, useEffect as useEffect4, useMemo as useMemo3, useState as useState7 } from "react";
import { IFrameClientServicesProxy, ShellDisplay as ShellDisplay2, ShellLayout as ShellLayout2 } from "@dxos/client";
import { MemoryShellRuntime } from "@dxos/client-services";
import { useClient as useClient7, useIdentity as useIdentity3 } from "@dxos/react-client";
import { mx as mx24 } from "@dxos/react-components";
var ShellContext = /* @__PURE__ */ createContext3({});
var useShell = () => {
  const client = useClient7();
  const { runtime, setDisplay } = useContext3(ShellContext);
  const setLayout = async (layout, options) => {
    if (runtime) {
      if (layout === ShellLayout2.DEFAULT) {
        setDisplay == null ? void 0 : setDisplay(ShellDisplay2.NONE);
      } else {
        setDisplay == null ? void 0 : setDisplay(ShellDisplay2.FULLSCREEN);
      }
      runtime.setLayout(layout, options);
    }
    if (client.services instanceof IFrameClientServicesProxy) {
      await client.services.setLayout(layout, options);
    }
  };
  return {
    setLayout
  };
};
var ShellProvider = ({ space, haloInvitationCode, spaceInvitationCode, onJoinedSpace, children }) => {
  useEffect4(() => {
    if (client.services instanceof IFrameClientServicesProxy && onJoinedSpace) {
      return client.services.joinedSpace.on(onJoinedSpace);
    }
  }, []);
  useEffect4(() => {
    if (client.services instanceof IFrameClientServicesProxy) {
      client.services.setSpaceProvider(() => space == null ? void 0 : space.key);
    }
  }, [
    space
  ]);
  const client = useClient7();
  const identity = useIdentity3();
  const [display, setDisplay] = useState7(!identity || spaceInvitationCode || haloInvitationCode ? ShellDisplay2.FULLSCREEN : ShellDisplay2.NONE);
  const shellRuntime = useMemo3(() => {
    if (client.config.get("runtime.app.env.DX_VAULT") !== "false") {
      return;
    }
    if (spaceInvitationCode) {
      return new MemoryShellRuntime({
        layout: ShellLayout2.JOIN_SPACE,
        invitationCode: spaceInvitationCode
      });
    }
    if (haloInvitationCode) {
      return new MemoryShellRuntime({
        layout: ShellLayout2.INITIALIZE_IDENTITY,
        invitationCode: haloInvitationCode
      });
    }
    return new MemoryShellRuntime({
      layout: ShellLayout2.DEFAULT
    });
  }, [
    client,
    identity,
    spaceInvitationCode,
    haloInvitationCode
  ]);
  const handleKeyDown = useCallback8((event) => {
    if (!space || !shellRuntime) {
      return;
    }
    const modifier = event.ctrlKey || event.metaKey;
    if (event.key === ">" && event.shiftKey && modifier) {
      shellRuntime.setLayout(ShellLayout2.DEVICE_INVITATIONS);
      setDisplay(ShellDisplay2.FULLSCREEN);
    } else if (event.key === "." && modifier) {
      shellRuntime.setLayout(ShellLayout2.SPACE_INVITATIONS, {
        spaceKey: space.key
      });
      setDisplay(ShellDisplay2.FULLSCREEN);
    }
  }, [
    space,
    shellRuntime
  ]);
  useEffect4(() => {
    if (!shellRuntime) {
      return;
    }
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [
    shellRuntime,
    handleKeyDown
  ]);
  useEffect4(() => {
    if (!shellRuntime) {
      return;
    }
    return shellRuntime.contextUpdate.on(({ display: display2, spaceKey }) => {
      setDisplay(display2);
      onJoinedSpace == null ? void 0 : onJoinedSpace(spaceKey);
    });
  }, [
    shellRuntime
  ]);
  return /* @__PURE__ */ React36.createElement(React36.Fragment, null, shellRuntime && /* @__PURE__ */ React36.createElement("div", {
    className: mx24(display === ShellDisplay2.NONE ? "hidden" : "")
  }, /* @__PURE__ */ React36.createElement(Shell, {
    runtime: shellRuntime,
    origin: window.location.origin
  })), /* @__PURE__ */ React36.createElement(ShellContext.Provider, {
    value: {
      runtime: shellRuntime,
      setDisplay
    }
  }, children));
};

// packages/apps/patterns/react-ui/src/translations/locales/en-US.ts
var en_US_exports = {};
__export(en_US_exports, {
  os: () => os
});
var os = {
  "manage profile label": "Manage identity",
  "identity offline description": "Offline",
  "sidebar label": "DXOS sidebar",
  "copy invitation code label": "Copy",
  "copy invitation code success label": "Copied",
  "open share panel label": "Share",
  "joining space heading": "Joining space",
  "join space heading": "Join a space",
  "halo heading": "Initialize device identity",
  "exit label": "Exit",
  "identity selector title": "Join as",
  "identity radio group title": "Select an identity you\u2019ve associated with this device already",
  "add identity label": "Add",
  "continue label": "Continue",
  "back label": "Back",
  "next label": "Next",
  "close label": "Close",
  "auth choices label": "Choose an identity",
  "create identity label": "Create an identity",
  "create identity description": "Create a new identity.",
  "recover identity label": "Use a seed phrase",
  "recover identity description": "Enter your seed phrase to log in manually.",
  "join identity label": "Use an authed device",
  "join identity description": "Add this device to an identity you\u2019re already logged into on another device.",
  "deselect identity label": "Back to identities",
  "addition method selector title": "An identity is required to continue",
  "new identity input label": "Add a display name",
  "recover identity input label": "Type or paste your seed phrase",
  "failed to create identity message": "Failed to create an identity.",
  "failed to recover identity message": "Failed to recover an identity from the provided seed phrase.",
  "failed to authenticate message": "Incorrect PIN.",
  "identity added label": "Created identity & added to this device:",
  "join space as identity heading": "<part>as </part><part><icon/><label>{{labelValue}}</label></part>",
  "error status label": "Failed",
  "timeout status label": "Timed out",
  "cancelled status label": "Cancelled",
  "init status label": "Ready to connect",
  "connecting status label": "Connecting\u2026",
  "connected status label": "Enter confirmation PIN",
  "authenticating status label": "Enter confirmation PIN",
  "success status label": "Success",
  "connect label": "Connect",
  "reconnect label": "Reconnect",
  "cancel label": "Cancel",
  "done label": "Done",
  "reset label": "Start over",
  "auth code input label": "Enter the verification code",
  "invitation input label": "Paste an invitation code or URL",
  "create device invitation label": "Invite",
  "create space invitation label": "Invite",
  "qr label": "Scan to accept invitation",
  "empty invitations message": "No pending invitations",
  "show all spaces label": "All spaces",
  "all spaces label": "All spaces",
  "create space label": "Create a new space",
  "join space label": "Join a space",
  "show current space label": "Current space",
  "view space invitations label": "View space invitations",
  "toggle sidebar label": "Open/close sidebar",
  "open sidebar label": "Open sidebar",
  "close sidebar label": "Close sidebar",
  "welcome message": "Welcome",
  "selecting identity heading": "Selecting identity"
};

// packages/apps/patterns/react-ui/src/translations/index.ts
var osTranslations = {
  "en-US": en_US_exports
};
export {
  ClipboardContext,
  ClipboardProvider,
  CopyButton,
  DeviceList,
  DevicesPanel,
  IdentityListItem,
  IdentityPanel,
  IdentityPopover,
  InvitationEmoji,
  InvitationList,
  InvitationListContainer,
  InvitationListItem,
  InvitationStatusAvatar,
  JoinDialog,
  JoinPanel,
  PanelAlertDialog,
  PanelDialog,
  PanelPopover,
  PanelSeparator,
  PanelSidebarContext,
  PanelSidebarProvider,
  Shell,
  ShellContext,
  ShellProvider,
  SpaceDialog,
  SpaceListItem,
  SpaceMemberList,
  SpaceMemberListContainer,
  SpacePanel,
  activeBgColor,
  activeStrokeColor,
  activeTextColor,
  cancelledBgColor,
  cancelledStrokeColor,
  cancelledTextColor,
  defaultArrow,
  defaultDialogContent,
  defaultOverlay,
  defaultSurface,
  errorBgColor,
  errorStrokeColor,
  errorTextColor,
  inactiveBgColor,
  inactiveStrokeColor,
  inactiveTextColor,
  osTranslations,
  resolvedBgColor,
  resolvedStrokeColor,
  resolvedTextColor,
  subduedSurface,
  successBgColor,
  successStrokeColor,
  successTextColor,
  useClipboardContext,
  useShell,
  useTogglePanelSidebar
};
//# sourceMappingURL=index.mjs.map
